const Proxy = globalThis.Proxy;
Proxy.prototype = {};

type FnOrPromisOrPrimitive =
    | (() => string | { [key: string]: string })
    | (() => Promise<string | { [key: string]: string }>)
    | string
    | { [key: string]: string };
export const _ = Symbol("_") as any;
export const OPTIONS = Symbol("OPTIONS");
export class RootOperation {
    public static authHeaderName = "Authorization";
    private resolveFnOrPromisOrPrimitiveHeaders = (
        arg?: FnOrPromisOrPrimitive,
    ) => {
        if (!arg) return undefined;
        let headers: Record<string, string> | undefined = undefined;
        if (typeof arg === "string") {
            headers = { [RootOperation.authHeaderName]: arg };
        } else if (typeof arg === "function") {
            const tokenOrPromise = arg();
            if (tokenOrPromise instanceof Promise) {
                return tokenOrPromise.then((t) => {
                    if (typeof t === "string")
                        headers = { [RootOperation.authHeaderName]: t };
                    else headers = t;

                    return headers;
                });
            }
            if (typeof tokenOrPromise === "string") {
                headers = { [RootOperation.authHeaderName]: tokenOrPromise };
            } else {
                headers = tokenOrPromise;
            }
        } else {
            headers = arg;
        }

        return headers;
    };

    constructor(
        public authArg?: FnOrPromisOrPrimitive,
        public headers?: FnOrPromisOrPrimitive,
    ) {}
    public setAuth(auth: FnOrPromisOrPrimitive) {
        this.authArg = auth;
        return this;
    }
    public setHeaders(headers: FnOrPromisOrPrimitive) {
        this.headers = headers;
        return this;
    }

    public static [OPTIONS] = {
        headers: {},
        fetcher: undefined as unknown as (
            input: string | URL | globalThis.Request,
            init?: RequestInit,
        ) => Promise<Response>,
        sseFetchTransform: undefined as unknown as (
            input: string | URL | globalThis.Request,
            init?: RequestInit,
        ) => Promise<
            [string | URL | globalThis.Request, RequestInit | undefined]
        >,

        _auth_fn: undefined as
            | (() => string | { [key: string]: string })
            | (() => Promise<string | { [key: string]: string }>)
            | undefined,
        scalars: {
            DateTime: (value: string) => new Date(value),
            DateTimeISO: (value: string) => new Date(value),
            Date: (value: string) => new Date(value),
            Time: (value: string) => new Date(value),
            JSON: (value: string) => JSON.parse(value),
        },
    };

    private utilSet = (obj: Record<string, any>, path: string[], value: any) =>
        path.reduce(
            (o, p, i, a) => (o[p] = a.length - 1 === i ? value : o[p] || {}),
            obj,
        );

    private rootCollector: OperationSelectionCollector | undefined = undefined;
    public registerRootCollector(collector: OperationSelectionCollector) {
        this.rootCollector = collector;
    }
    public async execute(headers: Record<string, string> = {}) {
        if (!this.rootCollector?.op) {
            throw new Error("RootOperation has no registered collector");
        }

        const authHeaders =
            await this.rootCollector.op!.resolveFnOrPromisOrPrimitiveHeaders(
                this.rootCollector.op!.authArg ??
                    RootOperation[OPTIONS]._auth_fn,
            );
        const headersHeaders =
            await this.rootCollector.op!.resolveFnOrPromisOrPrimitiveHeaders(
                this.rootCollector.op!.headers ??
                    RootOperation[OPTIONS].headers,
            );

        headers = {
            ...authHeaders,
            ...headersHeaders,
            ...headers,
        };

        type selection = ReturnType<
            typeof OperationSelectionCollector.prototype.renderSelections
        >;
        const operations: {
            [key: string]: {
                selection: selection;
                rootSlw: SelectionWrapperImpl<string, string, number, any>;
            };
        } = {};
        for (const [
            opName,
            opSelection,
        ] of this.rootCollector?.selections.entries()) {
            if (opSelection[SLW_LAZY_FLAG]) continue;

            let rootSlw = opSelection;
            while (!rootSlw[SLW_IS_ROOT_TYPE]) {
                if (!rootSlw[SLW_PARENT_SLW]) break;
                rootSlw = rootSlw[SLW_PARENT_SLW]!;
            }

            const selection = rootSlw[SLW_COLLECTOR]!.renderSelections(
                [opName],
                {},
                new Map(),
                opSelection === rootSlw ? [] : [opSelection],
            );

            operations[opName] = {
                selection,
                rootSlw,
            };
        }

        const ops = Object.entries(operations).reduce(
            (acc, [opName, { selection, rootSlw }]) => ({
                ...acc,
                [opName]: {
                    opType: rootSlw[SLW_IS_ROOT_TYPE]?.toLowerCase() as
                        | "subscription"
                        | "query"
                        | "mutation",
                    query: `${rootSlw[SLW_IS_ROOT_TYPE]?.toLowerCase()} ${opName} ${
                        selection.variableDefinitions.length
                            ? `(${selection.variableDefinitions.join(", ")}) `
                            : ""
                    }${selection.selection}`,
                    variables: selection.variables,
                    fragments: selection.usedFragments,
                },
            }),
            {} as Record<
                string,
                {
                    opType: "subscription" | "query" | "mutation";
                    query: string;
                    variables: any;
                    fragments: Map<string, string>;
                }
            >,
        );

        const results = Object.fromEntries(
            await Promise.all([
                ...Object.entries(ops).map(
                    async ([opName, op]) =>
                        [
                            opName,
                            op.opType === "subscription"
                                ? await this.subscribeOperation(op, headers)
                                : await this.executeOperation(op, headers),
                        ] as const,
                ),
            ]),
        );

        return results;
    }

    private async subscribeOperation(
        query: {
            opType: "subscription" | "query" | "mutation";
            query: string;
            variables: any;
            fragments: Map<string, string>;
        },
        headers: Record<string, string> = {},
    ): Promise<AsyncGenerator<any, void, unknown>> {
        const that = this;
        const generator = (async function* () {
            const [url, options] = (await (
                RootOperation[OPTIONS].sseFetchTransform ??
                ((url: string, options?: RequestInit) => [url, options])
            )("http://localhost:4000/graphql", {
                method: "POST",
                headers: {
                    ...headers,
                    "Content-Type": "application/json",
                    Accept: "text/event-stream",
                },
                body: JSON.stringify({
                    query: `${[...query.fragments.values()].join("\n")}\n ${query.query}`.trim(),
                    variables: query.variables,
                }),
            })) as [string | URL | Request, RequestInit];
            const response = await fetch(url, {
                ...options,
                headers: {
                    ...options?.headers,
                    "Content-Type": "application/json",
                    Accept: "text/event-stream",
                },
            });

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = "";

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const events = buffer.split("\n\n");
                buffer = events.pop() || "";

                for (const event of events) {
                    if (event.trim()) {
                        const eventName = event.match(/^event: (.*)$/m)?.[1];
                        const rawdata = event.match(/^data: (.*)$/m)?.[1];

                        if ((eventName === null && rawdata === "") || !rawdata)
                            continue;
                        if (eventName === "complete" || done) break;

                        const parsed = JSON.parse(rawdata) as {
                            data: any;
                            errors: any[];
                        };
                        const { data, errors } = parsed ?? {};
                        if (errors?.length > 0) {
                            if (!data) {
                                const err = new Error(JSON.stringify(errors), {
                                    cause: "Only errors were returned from the server.",
                                });
                                throw err;
                            }
                            for (const error of errors) {
                                if (error.path) {
                                    that.utilSet(data, error.path, error);
                                }
                            }
                        }

                        yield data;
                    }
                }
            }

            return;
        })();

        return generator;
    }

    private async executeOperation(
        query: {
            opType: "subscription" | "query" | "mutation";
            query: string;
            variables: any;
            fragments: Map<string, string>;
        },
        headers: Record<string, string> = {},
    ) {
        const res = await (RootOperation[OPTIONS].fetcher ?? globalThis.fetch)(
            "http://localhost:4000/graphql",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...headers,
                },
                body: JSON.stringify({
                    query: `${[...query.fragments.values()].join("\n")}\n ${query.query}`.trim(),
                    variables: query.variables,
                }),
            },
        );
        const result = (await res.json()) as { data: any; errors: any[] };

        const { data, errors } = result ?? {};
        if (errors?.length > 0) {
            if (!data) {
                const err = new Error(JSON.stringify(errors), {
                    cause: "Only errors were returned from the server.",
                });
                throw err;
            }
            for (const error of errors) {
                if (error.path) {
                    this.utilSet(data, error.path, error);
                }
            }
        }
        return data;
    }
}

export type OperationSelectionCollectorRef = {
    ref: OperationSelectionCollector;
};
export class OperationSelectionCollector {
    constructor(
        public readonly name?: string,
        public readonly parent?:
            | OperationSelectionCollector
            | OperationSelectionCollectorRef,
        public readonly op?: RootOperation,
    ) {
        if (op) op.registerRootCollector(this);
    }

    private executed = false;
    private operationResult: any | undefined = undefined;

    public cache: {
        data: Map<string, any>;
        proxiedArray: Map<string, any[]>;
    } = {
        data: new Map(),
        proxiedArray: new Map(),
    };

    public async execute(headers?: Record<string, string>) {
        if (!this.op) {
            throw new Error(
                "OperationSelectionCollector is not registered to a root operation",
            );
        }
        this.operationResult = await this.op.execute(headers);
        this.executed = true;
    }
    public get isExecuted() {
        return this.executed;
    }

    public readonly selections = new Map<
        string,
        SelectionWrapperImpl<string, string, number, any>
    >();
    public registerSelection(
        id: string,
        selection: SelectionWrapperImpl<string, string, number, any, any>,
    ) {
        this.selections.set(id, selection);
    }

    public renderSelections(
        path: string[] = [],
        opVars: Record<string, any> = {},
        usedFragments: Map<string, string> = new Map(),
        renderOnlyTheseSelections: SelectionWrapperImpl<
            string,
            string,
            number,
            any
        >[] = [],
    ) {
        const result: Record<string, string | undefined> = {};
        const varDefs: string[] = [];
        const variables: Record<string, any> = {};

        for (const [key, value] of [...this.selections.entries()].filter(
            ([k, v]) =>
                renderOnlyTheseSelections.length === 0 ||
                renderOnlyTheseSelections.find(
                    (r) => r[SLW_UID] === v[SLW_UID],
                ),
        )) {
            const subPath = [...path, key];
            const {
                selection: fieldSelection,
                variableDefinitions: fieldVarDefs,
                variables: fieldVars,

                directive: directiveRendered,
            } = value[SLW_RENDER_WITH_ARGS](opVars);

            Object.assign(variables, fieldVars);
            Object.assign(opVars, fieldVars);
            varDefs.push(...fieldVarDefs);

            if (directiveRendered) {
                const {
                    variableDefinitions: directiveVarDefs,
                    variables: directiveVars,
                } = directiveRendered;

                varDefs.push(...directiveVarDefs);
                Object.assign(variables, directiveVars);
                Object.assign(opVars, directiveVars);
            }

            value[SLW_REGISTER_PATH](subPath);

            if (value[SLW_PARENT_COLLECTOR] === undefined) {
                if (directiveRendered) {
                    result[key] =
                        `${fieldSelection} ${directiveRendered.rendered}`;
                } else {
                    result[key] = fieldSelection;
                }
            } else if (
                value[SLW_COLLECTOR] instanceof OperationSelectionCollector
            ) {
                const {
                    selection: subSelection,
                    variableDefinitions: subVarDefs,
                    variables: subVars,
                } = value[SLW_COLLECTOR].renderSelections(
                    subPath,
                    opVars,
                    usedFragments,
                );

                if (value[SLW_IS_ON_TYPE_FRAGMENT]) {
                    if (directiveRendered) {
                        result[key] =
                            `... on ${value[SLW_IS_ON_TYPE_FRAGMENT]} ${directiveRendered.rendered} ${subSelection}`;
                    } else {
                        result[key] =
                            `... on ${value[SLW_IS_ON_TYPE_FRAGMENT]} ${subSelection}`;
                    }
                } else if (value[SLW_IS_FRAGMENT]) {
                    const fragmentName = `${key}_${subVarDefs.map((v) => v.split(":")[0].slice(1)).join("_")}`;

                    if (directiveRendered) {
                        result[key] =
                            `...${fragmentName} ${directiveRendered.rendered}`;
                    } else {
                        result[key] = `...${fragmentName}`;
                    }

                    const fragment = `fragment ${fragmentName} on ${value[SLW_FIELD_TYPENAME]} ${subSelection}`;
                    if (!usedFragments.has(fragmentName)) {
                        usedFragments.set(fragmentName, fragment);
                    } else if (usedFragments.get(fragmentName) !== fragment) {
                        console.warn(
                            `Fragment ${fragmentName} is already defined with a different selection`,
                        );
                    }
                } else {
                    if (directiveRendered) {
                        result[key] =
                            `${fieldSelection} ${directiveRendered.rendered} ${subSelection}`;
                    } else {
                        result[key] = `${fieldSelection} ${subSelection}`;
                    }
                }

                Object.assign(variables, subVars);
                Object.assign(opVars, subVars);
                varDefs.push(...subVarDefs);
            }
        }
        let rendered = "{ ";
        for (const [key, value] of Object.entries(result).filter(
            ([k, v]) => v !== undefined,
        ) as [string, string][]) {
            const keyIsFieldName =
                value.startsWith(`${key} {`) || value.startsWith(`${key} (`);
            const isSubSelection = value.startsWith("{");
            const isOnType = value.startsWith("... on");
            const isFragment = value.startsWith("...");
            if (key === value) {
                rendered += `${key} `;
            } else if (isOnType || isFragment || keyIsFieldName) {
                rendered += `${value} `;
            } else {
                rendered += `${key}${!isSubSelection ? ":" : ""} ${value} `;
            }
        }
        rendered += "}";
        return {
            selection: rendered,
            variableDefinitions: varDefs,
            variables,
            usedFragments,
        };
    }

    private utilGet = (obj: Record<string, any>, path: (string | number)[]) =>
        path.reduce((o, p) => o?.[p], obj);
    public getOperationResultPath<T>(
        path: (string | number)[] = [],
        _type?: string,
        opResultDataOverride?: any,
    ): T {
        if (!this.op) {
            throw new Error(
                "OperationSelectionCollector is not registered to a root operation",
            );
        }

        let result = opResultDataOverride ?? this.operationResult;

        if (path.length === 0) return result as T;

        result = this.utilGet(result, path) as T;

        const type = _type?.replaceAll("!", "");
        if (type && result && type in RootOperation[OPTIONS].scalars) {
            let depth = 0;
            let finalResult = result instanceof Array ? [...result] : result;

            while (result instanceof Array) {
                result = result[0];
                depth++;
            }

            const deepParse = (
                res: any | any[],
                depth: number,
                parse: (v: string) => any,
            ) => {
                if (depth === 0) {
                    return parse(res);
                }
                return res.map((rarr: any) =>
                    deepParse(rarr, depth - 1, parse),
                );
            };

            return deepParse(
                finalResult,
                depth,
                RootOperation[OPTIONS].scalars[
                    type as keyof (typeof RootOperation)[typeof OPTIONS]["scalars"]
                ] ?? ((value: string) => JSON.parse(value)),
            ) as T;
        }

        return result as T;
    }
}

export const SLW_UID = Symbol("SLW_UID");
export const SLW_FIELD_NAME = Symbol("SLW_FIELD_NAME");
export const SLW_FIELD_TYPENAME = Symbol("SLW_FIELD_TYPENAME");
export const SLW_FIELD_ARR_DEPTH = Symbol("SLW_FIELD_ARR_DEPTH");
export const SLW_IS_ROOT_TYPE = Symbol("SLW_IS_ROOT_TYPE");
export const SLW_IS_ON_TYPE_FRAGMENT = Symbol("SLW_IS_ON_TYPE_FRAGMENT");
export const SLW_IS_FRAGMENT = Symbol("SLW_IS_FRAGMENT");
export const SLW_VALUE = Symbol("SLW_VALUE");
export const SLW_ARGS = Symbol("SLW_ARGS");
export const SLW_ARGS_META = Symbol("SLW_ARGS_META");
export const SLW_DIRECTIVE = Symbol("SLW_DIRECTIVE");
export const SLW_DIRECTIVE_ARGS = Symbol("SLW_DIRECTIVE_ARGS");
export const SLW_DIRECTIVE_ARGS_META = Symbol("SLW_DIRECTIVE_ARGS_META");
export const SLW_PARENT_SLW = Symbol("SLW_PARENT_SLW");
export const SLW_LAZY_FLAG = Symbol("SLW_LAZY_FLAG");

export const OP = Symbol("OP");
export const ROOT_OP_COLLECTOR = Symbol("ROOT_OP_COLLECTOR");
export const SLW_PARENT_COLLECTOR = Symbol("SLW_PARENT_COLLECTOR");
export const SLW_COLLECTOR = Symbol("SLW_COLLECTOR");
export const SLW_OP_PATH = Symbol("SLW_OP_PATH");
export const SLW_REGISTER_PATH = Symbol("SLW_REGISTER_PATH");
export const SLW_RENDER_WITH_ARGS = Symbol("SLW_RENDER_WITH_ARGS");

export const SLW_OP_RESULT_DATA_OVERRIDE = Symbol(
    "SLW_OP_RESULT_DATA_OVERRIDE",
);

export const SLW_RECREATE_VALUE_CALLBACK = Symbol(
    "SLW_RECREATE_VALUE_CALLBACK",
);
export const SLW_SETTER_DATA_OVERRIDE = Symbol("SLW_SETTER_DATA_OVERRIDE");
export const SLW_NEEDS_CLONE = Symbol("SLW_NEEDS_CLONE");

export const SLW_CLONE = Symbol("SLW_CLONE");

export class SelectionWrapperImpl<
    fieldName extends string,
    typeNamePure extends string,
    typeArrDepth extends number,
    valueT extends any = any,
    argsT extends Record<string, any> | undefined = undefined,
> {
    private generateUniqueId(): string {
        return (
            performance.now().toString(36) +
            Math.random().toString(36).substring(2)
        );
    }
    [SLW_CLONE](
        overrides: {
            SLW_OP_PATH?: string;
            OP_RESULT_DATA?: any;
            SLW_SETTER_DATA_OVERRIDE?: any;
            SLW_NEEDS_CLONE?: boolean;
        } = {},
    ) {
        const slw = new SelectionWrapper(
            this[SLW_FIELD_NAME],
            this[SLW_FIELD_TYPENAME],
            this[SLW_FIELD_ARR_DEPTH],
            this[SLW_VALUE],
            this[SLW_COLLECTOR],
            this[SLW_PARENT_COLLECTOR],
            this[SLW_ARGS],
            this[SLW_ARGS_META],
            this[SLW_RECREATE_VALUE_CALLBACK],
        );
        slw[SLW_IS_ROOT_TYPE] = this[SLW_IS_ROOT_TYPE];
        slw[SLW_IS_ON_TYPE_FRAGMENT] = this[SLW_IS_ON_TYPE_FRAGMENT];
        slw[SLW_IS_FRAGMENT] = this[SLW_IS_FRAGMENT];
        slw[SLW_PARENT_SLW] = this[SLW_PARENT_SLW];
        slw[SLW_OP_PATH] = overrides.SLW_OP_PATH ?? this[SLW_OP_PATH];
        slw[SLW_SETTER_DATA_OVERRIDE] =
            overrides.SLW_SETTER_DATA_OVERRIDE ??
            this[SLW_SETTER_DATA_OVERRIDE];

        slw[SLW_NEEDS_CLONE] = overrides.SLW_NEEDS_CLONE
            ? true
            : this[SLW_NEEDS_CLONE]
              ? false
              : true;

        if (overrides.OP_RESULT_DATA) {
            slw[SLW_OP_RESULT_DATA_OVERRIDE] = overrides.OP_RESULT_DATA;
        }

        return slw;
    }

    readonly [SLW_UID] = this.generateUniqueId();
    [ROOT_OP_COLLECTOR]?: OperationSelectionCollectorRef;
    [SLW_PARENT_COLLECTOR]?: OperationSelectionCollector;
    readonly [SLW_COLLECTOR]?: OperationSelectionCollector;

    [SLW_FIELD_NAME]?: fieldName;
    [SLW_FIELD_TYPENAME]?: typeNamePure;
    [SLW_FIELD_ARR_DEPTH]?: typeArrDepth;
    [SLW_VALUE]?: valueT;

    [SLW_IS_ROOT_TYPE]?: "Query" | "Mutation" | "Subscription";
    [SLW_IS_ON_TYPE_FRAGMENT]?: string;
    [SLW_IS_FRAGMENT]?: string;

    [SLW_ARGS]?: argsT;
    [SLW_ARGS_META]?: Record<string, string>;
    [SLW_DIRECTIVE]?: string;
    [SLW_DIRECTIVE_ARGS]?: Record<string, any>;
    [SLW_DIRECTIVE_ARGS_META]?: Record<string, string>;

    [SLW_PARENT_SLW]?: SelectionWrapperImpl<string, string, number, any, any>;
    [SLW_LAZY_FLAG]?: boolean;
    [SLW_RECREATE_VALUE_CALLBACK]?: () => valueT;

    [SLW_OP_RESULT_DATA_OVERRIDE]?: any;
    [SLW_SETTER_DATA_OVERRIDE]?: any;
    [SLW_NEEDS_CLONE]?: boolean;

    constructor(
        fieldName?: fieldName,
        typeNamePure?: typeNamePure,
        typeArrDepth?: typeArrDepth,
        value?: valueT,
        collector?: OperationSelectionCollector,
        parent?: OperationSelectionCollector | OperationSelectionCollectorRef,
        args?: argsT,
        argsMeta?: Record<string, string>,
        reCreateValueCallback?: () => valueT,
    ) {
        this[SLW_FIELD_NAME] = fieldName;
        this[SLW_FIELD_TYPENAME] = typeNamePure;
        this[SLW_FIELD_ARR_DEPTH] = typeArrDepth;
        this[SLW_VALUE] = value;

        this[SLW_ARGS] = args;
        this[SLW_ARGS_META] = argsMeta;

        if (parent instanceof OperationSelectionCollector) {
            this[SLW_PARENT_COLLECTOR] = parent;
        } else if (parent && "ref" in parent) {
            this[SLW_PARENT_COLLECTOR] = parent.ref;
        }

        if (collector instanceof OperationSelectionCollector) {
            this[SLW_COLLECTOR] = collector;

            let rootCollector = collector;
            while (
                rootCollector?.parent instanceof OperationSelectionCollector
            ) {
                rootCollector = rootCollector.parent;
            }
            if (rootCollector.parent && "ref" in rootCollector.parent) {
                this[ROOT_OP_COLLECTOR] = rootCollector.parent;
            }
        }

        if (reCreateValueCallback) {
            this[SLW_RECREATE_VALUE_CALLBACK] = reCreateValueCallback;
        }
    }

    [SLW_OP_PATH]?: string;
    [SLW_REGISTER_PATH](path: string[]) {
        if (!this[SLW_OP_PATH]) this[SLW_OP_PATH] = path.join(".");
    }
    [SLW_RENDER_WITH_ARGS](opVars: Record<string, any> = {}) {
        const renderArgsString = (
            args: Record<string, any>,
            argsMeta: Record<string, string>,
        ) => {
            const argToVarMap: Record<string, string> = {};
            let argsString = "(";
            const argsStringParts: string[] = [];
            for (const key of Object.keys(args)) {
                let varName = key;
                if (opVars[key] !== undefined) {
                    varName = `${key}_${
                        Object.keys(opVars).filter((k) => k.startsWith(key))
                            .length
                    }`;
                    argToVarMap[varName] = varName;
                    args[varName] = args[key];
                    argsMeta[varName] = argsMeta[key];
                    delete args[key];
                }
                argsStringParts.push(`${key}: $${varName}`);
            }
            argsString += argsStringParts.join(", ").trim() + ")";
            return { argsString, argToVarMap };
        };

        const directiveRender = {
            rendered: undefined as string | undefined,
            variables: {} as Record<string, any>,
            variableDefinitions: [] as string[],
        };
        if (this[SLW_DIRECTIVE]) {
            const directive = this[SLW_DIRECTIVE];

            if (this[SLW_DIRECTIVE_ARGS]) {
                const args = this[SLW_DIRECTIVE_ARGS];
                const argsMeta = this[SLW_DIRECTIVE_ARGS_META]!;

                const { argsString, argToVarMap } = renderArgsString(
                    args,
                    argsMeta,
                );

                directiveRender.rendered = `@${directive}${Object.keys(args).length ? argsString : ""}`;
                directiveRender.variables = args;
                directiveRender.variableDefinitions = Object.keys(args).map(
                    (key) => {
                        const varName = argToVarMap[key] ?? key;
                        return `$${varName}: ${argsMeta[key]}`;
                    },
                );
            } else {
                directiveRender.rendered = `@${directive}`;
            }
        }

        if (this[SLW_ARGS]) {
            const args = this[SLW_ARGS];
            const argsMeta = this[SLW_ARGS_META]!;

            const { argsString, argToVarMap } = renderArgsString(
                args,
                argsMeta,
            );
            return {
                selection: `${this[SLW_FIELD_NAME]}${Object.keys(args).length ? argsString : ""}`,
                variables: args,
                variableDefinitions: Object.keys(args).map((key) => {
                    const varName = argToVarMap[key] ?? key;
                    return `$${varName}: ${argsMeta[key]}`;
                }),

                directive: directiveRender.rendered
                    ? directiveRender
                    : undefined,
            };
        }
        return {
            selection: this[SLW_FIELD_NAME],
            variables: {},
            variableDefinitions: [] as string[],

            directive: directiveRender.rendered ? directiveRender : undefined,
        };
    }
}
export class SelectionWrapper<
    fieldName extends string,
    typeNamePure extends string,
    typeArrDepth extends number,
    valueT extends any = any,
    argsT extends Record<string, any> | undefined = undefined,
> extends Proxy<
    SelectionWrapperImpl<fieldName, typeNamePure, typeArrDepth, valueT, argsT>
> {
    constructor(
        fieldName?: fieldName,
        typeNamePure?: typeNamePure,
        typeArrDepth?: typeArrDepth,
        value?: valueT,
        collector?: OperationSelectionCollector,
        parent?: OperationSelectionCollector | OperationSelectionCollectorRef,
        args?: argsT,
        argsMeta?: Record<string, string>,
        reCreateValueCallback?: () => valueT,
    ) {
        super(
            new SelectionWrapperImpl<
                fieldName,
                typeNamePure,
                typeArrDepth,
                valueT,
                argsT
            >(
                fieldName,
                typeNamePure,
                typeArrDepth,
                value,
                collector,
                parent,
                args,
                argsMeta,
                reCreateValueCallback,
            ),
            (() => {
                const getCache = (
                    t: SelectionWrapperImpl<
                        fieldName,
                        typeNamePure,
                        typeArrDepth,
                        valueT,
                        argsT
                    >,
                ) => t[ROOT_OP_COLLECTOR]!.ref.cache;

                const getResultDataForTarget = (
                    t: SelectionWrapperImpl<
                        fieldName,
                        typeNamePure,
                        typeArrDepth,
                        valueT,
                        argsT
                    >,
                    overrideOpPath?: string,
                ): valueT | undefined => {
                    const cache = getCache(t);

                    const path = overrideOpPath ?? t[SLW_OP_PATH] ?? "";
                    if (cache.data.has(path) && !t[SLW_NEEDS_CLONE])
                        return cache.data.get(path);

                    const data = t[
                        ROOT_OP_COLLECTOR
                    ]!.ref.getOperationResultPath<valueT>(
                        (path?.split(".") ?? []).map((p) =>
                            !isNaN(+p) ? +p : p,
                        ),
                        t[SLW_FIELD_TYPENAME],
                        t[SLW_OP_RESULT_DATA_OVERRIDE],
                    );

                    cache.data.set(path, data);
                    return data;
                };

                return {
                    // implement ProxyHandler methods
                    ownKeys() {
                        return Reflect.ownKeys(value ?? {});
                    },
                    getOwnPropertyDescriptor(target, prop) {
                        return Reflect.getOwnPropertyDescriptor(
                            value ?? {},
                            prop,
                        );
                    },
                    has(target, prop) {
                        if (prop === Symbol.for("nodejs.util.inspect.custom"))
                            return true;
                        if (prop === Symbol.iterator && typeArrDepth) {
                            const dataArr = getResultDataForTarget(target);
                            if (Array.isArray(dataArr)) return true;
                            if (dataArr === undefined || dataArr === null)
                                return false;
                        }

                        return Reflect.has(value ?? {}, prop);
                    },
                    set(target, p, newValue, receiver) {
                        const pstr = String(p);
                        if (
                            typeof p === "symbol" &&
                            (pstr.startsWith("Symbol(SLW_") ||
                                pstr == "Symbol(ROOT_OP_COLLECTOR)")
                        ) {
                            return Reflect.set(target, p, newValue, receiver);
                        }
                        return Reflect.set(
                            target,
                            SLW_SETTER_DATA_OVERRIDE,
                            {
                                ...(target[SLW_SETTER_DATA_OVERRIDE] ?? {}),
                                [p]: newValue,
                            },
                            receiver,
                        );
                    },
                    get: (target, prop) => {
                        if (
                            target[SLW_SETTER_DATA_OVERRIDE] &&
                            target[SLW_SETTER_DATA_OVERRIDE][prop]
                        ) {
                            return target[SLW_SETTER_DATA_OVERRIDE][prop];
                        }
                        if (prop === "$lazy") {
                            const that = this;
                            function lazy(
                                this: {
                                    parentSlw: SelectionWrapperImpl<
                                        fieldName,
                                        typeNamePure,
                                        typeArrDepth,
                                        valueT,
                                        argsT
                                    >;
                                    key: string;
                                },
                                args?: argsT,
                            ) {
                                const { parentSlw, key } = this;
                                const newRootOpCollectorRef = {
                                    ref: new OperationSelectionCollector(
                                        undefined,
                                        undefined,
                                        new RootOperation(
                                            that[
                                                ROOT_OP_COLLECTOR
                                            ]!.ref.op!.authArg,
                                            that[
                                                ROOT_OP_COLLECTOR
                                            ]!.ref.op!.headers,
                                        ),
                                    ),
                                };

                                const newThisCollector =
                                    new OperationSelectionCollector(
                                        undefined,
                                        newRootOpCollectorRef,
                                    );
                                const r =
                                    that[SLW_RECREATE_VALUE_CALLBACK]?.bind(
                                        newThisCollector,
                                    )?.() ?? {};

                                const newThat = new SelectionWrapper(
                                    that[SLW_FIELD_NAME],
                                    that[SLW_FIELD_TYPENAME],
                                    that[SLW_FIELD_ARR_DEPTH],
                                    r,
                                    newThisCollector,
                                    // only set parent collector, if 'that' had one,
                                    // the absence indicates, that 'that' is a scalar field
                                    // without a subselection!
                                    that[SLW_PARENT_COLLECTOR]
                                        ? newRootOpCollectorRef
                                        : undefined,
                                    that[SLW_ARGS],
                                    that[SLW_ARGS_META],
                                );
                                Object.keys(r!).forEach(
                                    (key) =>
                                        (newThat as valueT)[
                                            key as keyof valueT
                                        ],
                                );

                                newThat[SLW_IS_ROOT_TYPE] =
                                    that[SLW_IS_ROOT_TYPE];
                                newThat[SLW_IS_ON_TYPE_FRAGMENT] =
                                    that[SLW_IS_ON_TYPE_FRAGMENT];
                                newThat[SLW_IS_FRAGMENT] =
                                    that[SLW_IS_FRAGMENT];

                                newThat[SLW_PARENT_SLW] = parentSlw;
                                parentSlw[SLW_COLLECTOR]?.registerSelection(
                                    key,
                                    newThat,
                                );
                                newThat[SLW_ARGS] = {
                                    ...(that[SLW_ARGS] ?? {}),
                                    ...args,
                                } as argsT;

                                newThat[SLW_OP_PATH] = that[SLW_OP_PATH];

                                newRootOpCollectorRef.ref.registerSelection(
                                    newThat[SLW_FIELD_NAME]!,
                                    newThat,
                                );

                                const resultProxy = new Proxy(
                                    {},
                                    {
                                        get(_t, _prop) {
                                            const result = new Promise(
                                                (resolve, reject) => {
                                                    newRootOpCollectorRef.ref
                                                        .execute()
                                                        .catch(reject)
                                                        .then(() => {
                                                            resolve(newThat);
                                                        });
                                                },
                                            );
                                            if (String(_prop) === "then") {
                                                return result.then.bind(result);
                                            }
                                            return result;
                                        },
                                    },
                                ) as any;

                                return new Proxy(
                                    {},
                                    {
                                        get(_t, _prop) {
                                            if (String(_prop) === "auth") {
                                                return (
                                                    auth: FnOrPromisOrPrimitive,
                                                ) => {
                                                    newRootOpCollectorRef.ref.op!.setAuth(
                                                        auth,
                                                    );
                                                    return resultProxy;
                                                };
                                            }
                                            return resultProxy[_prop];
                                        },
                                    },
                                );
                            }
                            target[SLW_LAZY_FLAG] = true;
                            lazy[SLW_LAZY_FLAG] = true;
                            return lazy;
                        }
                        if (
                            prop === SLW_UID ||
                            prop === SLW_FIELD_NAME ||
                            prop === SLW_FIELD_TYPENAME ||
                            prop === SLW_FIELD_ARR_DEPTH ||
                            prop === SLW_IS_ROOT_TYPE ||
                            prop === SLW_IS_ON_TYPE_FRAGMENT ||
                            prop === SLW_IS_FRAGMENT ||
                            prop === SLW_VALUE ||
                            prop === SLW_ARGS ||
                            prop === SLW_ARGS_META ||
                            prop === SLW_DIRECTIVE ||
                            prop === SLW_DIRECTIVE_ARGS ||
                            prop === SLW_DIRECTIVE_ARGS_META ||
                            prop === SLW_PARENT_SLW ||
                            prop === SLW_LAZY_FLAG ||
                            prop === ROOT_OP_COLLECTOR ||
                            prop === SLW_PARENT_COLLECTOR ||
                            prop === SLW_COLLECTOR ||
                            prop === SLW_OP_PATH ||
                            prop === SLW_REGISTER_PATH ||
                            prop === SLW_RENDER_WITH_ARGS ||
                            prop === SLW_RECREATE_VALUE_CALLBACK ||
                            prop === SLW_OP_RESULT_DATA_OVERRIDE ||
                            prop === SLW_CLONE ||
                            prop === SLW_SETTER_DATA_OVERRIDE
                        ) {
                            return target[
                                prop as keyof SelectionWrapperImpl<
                                    fieldName,
                                    typeNamePure,
                                    typeArrDepth,
                                    valueT
                                >
                            ];
                        }
                        if (prop === SLW_VALUE) {
                            return value;
                        }
                        if (prop === "then") {
                            return this;
                        }

                        let slw_value = target[SLW_VALUE] as
                            | Record<string, any>
                            | undefined;

                        if (target[ROOT_OP_COLLECTOR]?.ref.isExecuted) {
                            if (prop === Symbol.asyncIterator) {
                                const asyncGenRootPath =
                                    target[SLW_OP_PATH]?.split(".")?.[0];
                                const asyncGen = getResultDataForTarget(
                                    target,
                                    asyncGenRootPath,
                                ) as AsyncGenerator<valueT, any, any>;

                                return function () {
                                    return {
                                        next() {
                                            return asyncGen
                                                .next()
                                                .then((val) => {
                                                    return {
                                                        done: val.done,
                                                        value: target[
                                                            SLW_CLONE
                                                        ]({
                                                            SLW_OP_PATH:
                                                                asyncGenRootPath,
                                                            OP_RESULT_DATA:
                                                                val.value,

                                                            // this is only for subscriptions
                                                            SLW_NEEDS_CLONE:
                                                                true,
                                                        }),
                                                    };
                                                });
                                        },
                                    };
                                };
                            }

                            if (!Object.hasOwn(slw_value ?? {}, String(prop))) {
                                const _data = getResultDataForTarget(target);
                                const path = target[SLW_OP_PATH]!;

                                // check if the selected field is an array
                                if (typeArrDepth && Array.isArray(_data)) {
                                    if (!isNaN(+String(prop))) {
                                        const elm = target[SLW_CLONE]({
                                            SLW_OP_PATH:
                                                path + "." + String(prop),
                                            OP_RESULT_DATA:
                                                target[
                                                    SLW_OP_RESULT_DATA_OVERRIDE
                                                ],
                                        });
                                        return elm;
                                    }

                                    const data = _data as valueT[] | undefined;

                                    if (data === undefined) return undefined;
                                    const cache = getCache(target);

                                    const proxiedData =
                                        cache.proxiedArray.get(
                                            target[SLW_OP_PATH]!,
                                        ) ??
                                        Array.from(
                                            { length: data.length },
                                            (_, i) =>
                                                target[SLW_CLONE]({
                                                    SLW_OP_PATH:
                                                        target[SLW_OP_PATH] +
                                                        "." +
                                                        String(i),
                                                    OP_RESULT_DATA:
                                                        target[
                                                            SLW_OP_RESULT_DATA_OVERRIDE
                                                        ],
                                                }),
                                        );

                                    if (!cache.proxiedArray.has(path)) {
                                        cache.proxiedArray.set(
                                            path,
                                            proxiedData,
                                        );
                                    }

                                    const proto =
                                        Object.getPrototypeOf(proxiedData);
                                    if (Object.hasOwn(proto, prop)) {
                                        const v = (proxiedData as any)[prop];
                                        if (typeof v === "function")
                                            return v.bind(proxiedData);
                                        return v;
                                    }

                                    if (data === undefined) return undefined;
                                    if (data === null) return null;

                                    return (proxiedData as any)[prop];
                                }

                                const data = _data as valueT | undefined;
                                if (data === undefined) return undefined;
                                if (data === null) return null;

                                const proto = Object.getPrototypeOf(data);
                                if (Object.hasOwn(proto, prop)) {
                                    const v = (data as any)[prop];
                                    if (typeof v === "function")
                                        return v.bind(data);
                                    return v;
                                }

                                return (data as any)[prop];
                            }

                            let slw = slw_value?.[String(prop)];
                            let slwOpPathIsIndexAccessOrInArray = false;
                            let targetOpPathArr =
                                target[SLW_OP_PATH]?.split(".") ?? [];
                            while (targetOpPathArr.length) {
                                if (!isNaN(+targetOpPathArr.pop()!)) {
                                    slwOpPathIsIndexAccessOrInArray = true;
                                    break;
                                }
                            }

                            if (
                                slwOpPathIsIndexAccessOrInArray ||
                                (target[SLW_OP_RESULT_DATA_OVERRIDE] &&
                                    !slw[SLW_OP_RESULT_DATA_OVERRIDE])
                            ) {
                                if (target[SLW_NEEDS_CLONE]) {
                                    // if the slw is flagged it needs to be cloned
                                    // this is only for subscriptions, because
                                    // the original slw will continue to exist
                                    // and also have the same op path
                                    // we need a new object that doesn't reference
                                    // the other objects
                                    slw = slw[SLW_CLONE]({
                                        SLW_OP_PATH:
                                            target[SLW_OP_PATH] +
                                            "." +
                                            String(prop),
                                        OP_RESULT_DATA:
                                            target[SLW_OP_RESULT_DATA_OVERRIDE],
                                    });
                                } else {
                                    // index access detected, setting the op path
                                    // with the index (coming from the slw's parent (target))
                                    // it's in the parent because the parent was cloned before
                                    slw[SLW_OP_PATH] =
                                        target[SLW_OP_PATH] +
                                        "." +
                                        String(prop);
                                    slw[SLW_OP_RESULT_DATA_OVERRIDE] =
                                        target[SLW_OP_RESULT_DATA_OVERRIDE];
                                }
                            }

                            if (
                                slw instanceof SelectionWrapperImpl &&
                                slw[SLW_FIELD_ARR_DEPTH]
                            ) {
                                const dataArr = getResultDataForTarget(slw) as
                                    | unknown[]
                                    | undefined
                                    | null;
                                if (dataArr === undefined) return undefined;
                                if (dataArr === null) return null;
                                if (!dataArr?.length) {
                                    return [];
                                }
                            } else if (slw instanceof SelectionWrapperImpl) {
                                const data = getResultDataForTarget(slw) as
                                    | unknown
                                    | undefined
                                    | null;
                                if (data === undefined) return undefined;
                                if (data === null) return null;
                            }

                            if (
                                slw instanceof SelectionWrapperImpl &&
                                slw[SLW_PARENT_COLLECTOR]
                            ) {
                                return slw;
                            } else if (slw instanceof SelectionWrapperImpl) {
                                return getResultDataForTarget(slw);
                            } else if (slw[SLW_LAZY_FLAG]) {
                                return slw;
                            }

                            return getResultDataForTarget(target);
                        }

                        if (
                            Object.hasOwn(slw_value ?? {}, String(prop)) &&
                            slw_value?.[String(prop)] instanceof
                                SelectionWrapperImpl
                        ) {
                            if (target[SLW_COLLECTOR]) {
                                target[SLW_COLLECTOR].registerSelection(
                                    String(prop),
                                    slw_value[String(prop)],
                                );
                            }
                            if (!slw_value[String(prop)][SLW_PARENT_SLW]) {
                                slw_value[String(prop)][SLW_PARENT_SLW] =
                                    target;
                            }
                        }
                        if (slw_value?.[String(prop)]?.[SLW_LAZY_FLAG]) {
                            if (!slw_value[String(prop)][SLW_PARENT_SLW]) {
                                const lazyFn = slw_value[String(prop)];
                                slw_value[String(prop)] = lazyFn.bind({
                                    parentSlw: target,
                                    key: String(prop),
                                });
                                slw_value[String(prop)][SLW_PARENT_SLW] =
                                    target;
                                slw_value[String(prop)][SLW_LAZY_FLAG] = true;
                            }
                        }

                        return slw_value?.[String(prop)] ?? undefined;
                    },
                };
            })(),
        );
    }
}


    export interface ScalarTypeMapWithCustom {
        "Weekday": 1 | 2 | 3 | 4 | 5 | 6;
"stringOrNumberDecimal": string_NumberDecimal;
    }
    export interface ScalarTypeMapDefault {
        "String": string;
"Int": number;
"Float": number;
"Boolean": boolean;
"ID": string;
"Date": Date;
"DateTime": Date;
"DateTimeISO": Date;
"Time": Date;
"JSON": Record<string, any>;
    };

    type SelectionFnParent = {
        collector: OperationSelectionCollector | OperationSelectionCollectorRef;
        fieldName?: string;
        args?: Record<string, any>;
        argsMeta?: Record<string, string>;

        isRootType?: "Query" | "Mutation" | "Subscription";
        onTypeFragment?: string;
        isFragment?: string;
    } | undefined;

    type CleanupNever<A> = Omit<A, keyof A> & {
        [K in keyof A as A[K] extends never ? never : K]: A[K];
    };
    type Prettify<T> = (
        T extends Array<infer U>
        ? U[] : {
            [K in keyof T]: T[K];
        }
    ) & {};

    type SLWsFromSelection<
        S,
        R = {
            [K in keyof S]: S[K] extends SelectionWrapperImpl<
                infer FN,
                infer TNP,
                infer TAD
            >
                ? S[K]
                : never;
        },
    > = Prettify<CleanupNever<R>>;
    type ReturnTypeFromFragment<T> = T extends (
        this: any,
        ...args: any[]
    ) => infer R
        ? R
        : never;
    type ArgumentsTypeFromFragment<T> = T extends (
        this: any,
        ...args: infer A
    ) => any
        ? A
        : never;

    type ReplaceReturnType<T, R, E = unknown> = T extends (
        ...a: any
    ) => (...a: any) => any
        ? (
            ...a: Parameters<T>
        ) => ReturnType<ReturnType<T>> extends Promise<any>
            ? Promise<R> & E
            : R & E
        : T extends (...a: any) => any
        ? (
                ...a: Parameters<T>
            ) => ReturnType<T> extends Promise<any> ? Promise<R> & E : R & E
        : never;
    type SLW_TPN_ToType<
        TNP extends string,
        TNP_TYPE = TNP extends `${infer _TNP}!` ? _TNP : TNP,
        IS_NULLABLE = TNP extends `${infer _TNP}!` ? false : true,
        RESULT = TNP_TYPE extends keyof ScalarTypeMapWithCustom
            ? ScalarTypeMapWithCustom[TNP_TYPE]
            : TNP_TYPE extends keyof ScalarTypeMapDefault
            ? ScalarTypeMapDefault[TNP_TYPE]
            : TNP_TYPE extends keyof EnumTypesMapped
                ? EnumTypesMapped[TNP_TYPE]
                : never,
> = IS_NULLABLE extends true ? RESULT | null : RESULT;
    type Prev = [never, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, ...0[]];
    type ToTArrayWithDepth<T, D extends number> = D extends 0
        ? T
        : ToTArrayWithDepth<T[], Prev[D]>;
    type ConvertToPromise<T, skip = 1> = skip extends 0 ? T : Promise<T>;
    type ConvertToAsyncIter<T, skip = 1> = skip extends 0 ? T : AsyncIterable<T>;
    type ReplacePlaceHoldersWithTNested<
        inferedResult,
        EE,
        REP extends string | number | symbol,
    > = {
        [k in keyof EE]: k extends REP
            ? EE[k] extends (...args: any) => infer R
                ? ReplaceReturnType<
                    EE[k],
                    inferedResult,
                    {
                        [kk in Exclude<REP, k>]: kk extends keyof R
                            ? ReplaceReturnType<R[kk], inferedResult>
                            : never;
                    }
                >
                : inferedResult
            : EE[k];
    };

    export type SLFN<
        T extends object,
        F,
        N extends string,
        TNP extends string,
        TAD extends number,
        E extends { [key: string | number | symbol]: any } = {},
        REP extends string | number | symbol = never,
        AS_PROMISE = 0,
        AS_ASYNC_ITER = 0,
    > = (
        makeSLFNInput: () => F,
        SLFN_name: N,
        SLFN_typeNamePure: TNP,
        SLFN_typeArrDepth: TAD,
    ) => <
        TT = T,
        FF = F,
        EE = E,
        inferedResult = {
            [K in keyof TT]: TT[K] extends SelectionWrapperImpl<
                infer FN,
                infer TTNP,
                infer TTAD,
                infer VT,
                infer AT
            >
                ? ToTArrayWithDepth<SLW_TPN_ToType<TTNP>, TTAD>
                : TT[K];
        },
    >(
        this: any,
        s: (selection: FF) => TT,
    ) => Prettify<
            ConvertToPromise<
                ConvertToAsyncIter<ToTArrayWithDepth<inferedResult, TAD>, AS_ASYNC_ITER>,
                AS_PROMISE
            > &
            ReplacePlaceHoldersWithTNested<
                ConvertToAsyncIter<ToTArrayWithDepth<inferedResult, TAD>, AS_ASYNC_ITER>,
                EE,
                REP
            >
        >;
    

    const selectScalars = (selection: Record<string, any>) =>
        Object.fromEntries(
            Object.entries(selection).filter(
                ([k, v]) => v instanceof SelectionWrapperImpl,
            ),
        );
    
    type AllNonFuncFieldsFromType<
        TRaw,
        T = TRaw extends Array<infer A> ? A : TRaw,
    > = Pick<
        T,
        { [k in keyof T]: T[k] extends (args: any) => any ? never : k }[keyof T]
    >;

    type SetNestedFieldNever<
        T,
        Path extends string,
    > = Path extends `${infer Key}.${infer Rest}`
        ? Key extends keyof T
            ? {
                [K in keyof T]: K extends Key
                    ? SetNestedFieldNever<T[K], Rest>
                    : T[K];
            }
            : T
        : { [K in keyof T]: K extends Path ? never : T[K] };

    type primitives =
        | string
        | number
        | boolean
        | Record<string | number | symbol, unknown>;
    type isScalar<T> =
        T extends Exclude<
            ScalarTypeMapDefault[keyof ScalarTypeMapDefault],
            primitives
        >
            ? true
            : T extends Exclude<
                    ScalarTypeMapWithCustom[keyof ScalarTypeMapWithCustom],
                    primitives
                >
            ? true
            : false;

    // Utility type to get all possible dot-notation paths
    type Paths<T, Visited = never, Depth extends Prev[number] = 9> =
        isScalar<T> extends true
            ? never
            : Depth extends never
            ? never
            : T extends object
                ? T extends Visited
                    ? never // Stop recursion if type is cyclic
                    : {
                        [K in keyof T]: T[K] extends Array<infer U>
                            ? K extends string | number
                                ?
                                        | `${K}`
                                        | `${K}.${Paths<U, Visited | T, Prev[Depth]>}`
                                : never
                            : K extends string | number
                                ? T[K] extends object
                                    ?
                                        | `${K}`
                                        | `${K}.${Paths<T[K], Visited | T, Prev[Depth]>}`
                                    : `${K}`
                                : never;
                    }[keyof T]
                : never;

    // Utility type to get only cyclic paths
    type CyclicPaths<
        T,
        Visited = never,
        Depth extends Prev[number] = 9,
        Prefix extends string = "",
    > =
        isScalar<T> extends true
            ? never
            : Depth extends never
            ? never
            : T extends object
                ? {
                    [K in keyof T]: T[K] extends Array<infer U>
                        ? K extends string | number
                            ? U extends Visited
                                ? `${Prefix}${K}` // Cyclic path found for array element
                                : CyclicPaths<
                                        U,
                                        Visited | T,
                                        Prev[Depth],
                                        `${Prefix}${K}.`
                                    >
                            : never
                        : K extends string | number
                            ? T[K] extends Visited
                                ? `${Prefix}${K}` // Cyclic path found
                                : T[K] extends object
                                ? CyclicPaths<
                                        T[K],
                                        Visited | T,
                                        Prev[Depth],
                                        `${Prefix}${K}.`
                                    >
                                : never
                            : never;
                }[keyof T]
                : never;

    // Utility type to exclude multiple paths
    type OmitMultiplePaths<T, Paths extends string> = Paths extends any
        ? SetNestedFieldNever<T, Paths>
        : T;
    type UnionToIntersection<U> = (U extends any ? (x: U) => void : never) extends (
        x: infer I,
    ) => void
        ? I
        : never;
    type MergeUnion<T> = UnionToIntersection<T>;
    type TurnToArray<T, yes extends boolean> = yes extends true ? T[] : T;
    type OmitNever<
        TRaw,
        TisArray extends boolean = TRaw extends Array<any> ? true : false,
        T = TRaw extends Array<infer A> ? A : TRaw
    > = isScalar<T> extends true
        ? TurnToArray<T, TisArray>
        : T extends object
        ? TurnToArray<
                {
                    [K in keyof T as T[K] extends never ? never : T[K] extends never[] ? never : K]: isScalar<T[K]> extends true
                        ? T[K]
                        : T[K] extends object
                        ? OmitNever<T[K]>
                        : T[K];
                },
                TisArray
        >
        : TurnToArray<T, TisArray>;

    const selectCyclicFieldsOptsStr = "select cyclic levels: ";
    type selectCyclicFieldsOptsStrType = typeof selectCyclicFieldsOptsStr;
    type cyclicOpts<
        S,
        CP = CyclicPaths<S>,
        kOpts = "exclude" | `${selectCyclicFieldsOptsStrType}${1 | 2 | 3 | 4 | 5}`,
    > = CP extends never
        ? never
        : {
            [k in CP & string]: kOpts;
        };

    type Next = [1, 2, 3, 4, 5, 6, 7, 8, 9, ...0[]];
    type StringToNumber<S extends string> = S extends `${infer N extends number}`
        ? N
        : never;

    type getNumberNestedLevels<str extends string> =
        str extends `${selectCyclicFieldsOptsStrType}${infer n}`
            ? StringToNumber<n>
            : never;

    type selectAllOpts<S> =
        | {
                exclude?: Paths<S>[];
        }
        | {
                exclude?: Paths<S>[];
                cyclic: cyclicOpts<S>;
        };
    type RepeatString<
        S extends string,
        N extends number,
        Splitter extends string = "",
        Acc extends string = "",
        Count extends number = N,
    > = Count extends 0
        ? Acc
        : RepeatString<
            S,
            N,
            Splitter,
            `${Acc}${Acc extends "" ? "" : Splitter}${S}`,
            Prev[Count]
        >;

    type GetSuffix<
        Str extends string,
        Prefix extends string,
    > = Str extends `${Prefix}${infer Suffix}` ? Suffix : never;

    type selectAllFunc<T, TNP extends string> = <const P = Paths<T>, const CP_WITH_TNP = cyclicOpts<T, `${TNP}.${CyclicPaths<T>}`>>(
        opts: CyclicPaths<T> extends never
            ? {
                    exclude?: `${TNP}.${P & string}`[];
            }
            : {
                    exclude?: `${TNP}.${P & string}`[];
                    cyclic: CP_WITH_TNP;
            }
    ) => OmitNever<
        MergeUnion<
            OmitMultiplePaths<
                T,
                | (Exclude<Paths<T>, P> extends never ? "" : P & string)
                | (
                        CP_WITH_TNP extends never
                        ? ""
                        : {
                                [k in keyof CP_WITH_TNP]: "exclude" extends CP_WITH_TNP[k]
                                    ? GetSuffix<k & string, `${TNP}.`>
                                    : RepeatString<
                                            GetSuffix<k & string, `${TNP}.`>,
                                            Next[getNumberNestedLevels<CP_WITH_TNP[k] & string>],
                                            "."
                                    >;
                            }[keyof CP_WITH_TNP]
                    )
            >
        >
    >;

    const selectAll = <
        S,
        TNP extends string,
        SUB extends ReturnType<SLFN<{}, unknown, string, string, number>>,
        V extends
            | (SelectionWrapperImpl<any, any, any> | SUB)
            | ((args: any) => SelectionWrapperImpl<any, any, any> | SUB),
    >(
        selection: Record<string, V>,
        typeNamePure: TNP,
        opts: selectAllOpts<S>,
        collector?: { parents: string[]; path?: string },
    ) => {
        // let's not make the type too complicated, it's basically a
        // nested map of string to either SLW or again
        // a map of string to SLW
        const s: Record<string, any> = {};
        const entries = Object.entries(selection);
        for (const [k, v] of entries) {
            const tk = collector?.path
                ? `${collector.path}.${k}`
                : `${typeNamePure}.${k}`;
            let excludePaths = opts?.exclude ?? ([] as string[]);
            if ("cyclic" in opts) {
                const exclude = Object.entries(
                    opts.cyclic as Record<string, string>,
                )
                    .filter(([k, v]) => v === "exclude")
                    .map((e) => e[0]);
                const cyclicLevels = Object.entries(
                    opts.cyclic as Record<string, string>,
                )
                    .filter(([k, v]) => v !== "exclude")
                    .map((e) => {
                        const levels = parseInt(
                            e[1]
                                .match(new RegExp(`${selectCyclicFieldsOptsStr}(.*)`))!
                                .at(1)![0],
                        ) + 1;
                        const pathFragment = e[0].split(".").slice(1).join(".");
                        return `${e[0].split(".")[0]}.${Array.from({ length: levels }).fill(pathFragment).join(".")}`;
                    });
                excludePaths.push(...exclude, ...cyclicLevels);
            }
            if (excludePaths.includes(tk as any)) continue;

            if (typeof v === "function") {
                if (v.name.startsWith("bound ")) {
                    // if (collector?.parents?.includes(tk)) continue;
                    const col = {
                        parents: [...(collector?.parents ?? []), tk],
                        path: tk,
                    };
                    s[k] = v(
                        (sub_s: {
                            $on?: { [k: string]: (utype_sub: (utype_sub_s: { $all: (_opts?: {}, collector?: {}) => any }) => any) => any };
                            $all?: (_opts?: {}, collector?: {}) => any;
                        }) => {
                            if (sub_s.$all) {
                                return sub_s.$all(opts, col);
                            }
                            if (sub_s.$on) {
                                return Object.values(sub_s.$on).reduce(
                                    (sel, tselfn) => ({
                                        ...sel,
                                        ...tselfn(utype_sub_s => {
                                            return utype_sub_s.$all(opts, col);
                                        }),
                                    }),
                                    {}
                                );
                            }
                        }
                    );
                } else if (!k.startsWith("$")) {
                    console.warn(
                        `Cannot use $all on fields with args: ${k}: ${v.toString()}`,
                    );
                }
            } else {
                s[k] = v;
            }
        }
        return s;
    };

    const makeSLFN = <
        T extends object,
        F,
        N extends string,
        TNP extends string,
        TAD extends number,
    >(
        makeSLFNInput: () => F,
        SLFN_name: N,
        SLFN_typeNamePure: TNP,
        SLFN_typeArrDepth: TAD,
    ) => {
        function _SLFN<TT extends T, FF extends F>(
            this: any,
            s: (selection: FF) => TT,
        ) {
            let parent: SelectionFnParent = this ?? {
                collector: new OperationSelectionCollector(),
            };
            function innerFn(this: any) {
                const selection: FF = makeSLFNInput.bind(this)() as any;
                const r = s(selection);
                const _result = new SelectionWrapper(
                    parent?.fieldName,
                    SLFN_typeNamePure,
                    SLFN_typeArrDepth,
                    r,
                    this,
                    parent?.collector,
                    parent?.args,
                    parent?.argsMeta,
                    function (this: OperationSelectionCollector) {
                        return s(makeSLFNInput.bind(this)() as FF);
                    },
                );
                _result[SLW_IS_ROOT_TYPE] = parent?.isRootType;
                _result[SLW_IS_ON_TYPE_FRAGMENT] = parent?.onTypeFragment;
                _result[SLW_IS_FRAGMENT] = parent?.isFragment;

                Object.keys(r).forEach((key) => (_result as T)[key as keyof T]);
                const result = _result as unknown as T;

                if (parent?.onTypeFragment) {
                    return {
                        [parent.onTypeFragment]: result,
                    } as unknown as typeof result;
                }
                if (parent?.isFragment) {
                    return {
                        [parent.isFragment]: result,
                    } as unknown as typeof result;
                }

                return result;
            }
            return innerFn.bind(
                new OperationSelectionCollector(SLFN_name, parent?.collector),
            )();
        }
        return _SLFN as ReturnType<SLFN<T, F, N, TNP, TAD>>;
    };
    

            export type Currency = "EUR" | "CHF" | "ISK" | "CZK";
            export enum CurrencyEnum {
                EUR = "EUR",
CHF = "CHF",
ISK = "ISK",
CZK = "CZK",
            };
        

            export type Constant_Polygon = "Polygon";
            export enum Constant_PolygonEnum {
                Polygon = "Polygon",
            };
        
export type Directive_includeArgs = { 
                /** Included when true. */
                if: boolean; };
export type Directive_skipArgs = { 
                /** Skipped when true. */
                if: boolean; };
export type QueryMapsPoiVenuesArgs = { 
                        customerGroup: string; 
                        filter?: _postalCode_string_lat_number_lng_number_distance_number_Input; };
export const Directive_includeArgsMeta = { if: "Boolean!", } as const;
export const Directive_skipArgsMeta = { if: "Boolean!", } as const;
export const QueryMapsPoiVenuesArgsMeta = { customerGroup: "String!", filter: "_postalCode_string_lat_number_lng_number_distance_number_Input", } as const;

            export type _postalCode_string_lat_number_lng_number_distance_number_Input = {
                postalCode?: string;
lat?: number;
lng?: number;
distance?: number;
            };
        

            export type MapsPoiVenue = {
                _id: string;
readableId?: string;
name: string;
isPublished?: boolean;
isServiceActivated?: boolean;
currency: Currency;
preorderTable?: string;
openingHours?: Hours[];
deliveryHours?: Hours[];
specialOpeningHours?: Partial_SpecialHours_[];
specialDeliveryHours?: _Duplicate1_Partial_SpecialHours_[];
cateringHoursTakeAway?: Hours[];
panicEndAt?: Date;
preorderTakeAway: boolean;
preorderIn: boolean;
deliveryEnabled?: boolean;
deliveryByAreas?: boolean;
deliveryByRadius?: boolean;
isPostalDelivery?: boolean;
deliveryAreas?: DeliveryArea[];
deliveryPostalCodes?: Array<string>;
deliveryRadius?: number;
distance?: number;
cateringTakeAway?: boolean;
cateringDelivery?: boolean;
offsets?: Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_;
firstPreorderOffset?: number;
preorderOffset?: number;
lastPreorderOffset?: number;
city: Localization;
street?: string;
number?: string;
phoneNumber?: string;
address?: string;
country: string;
website?: string;
postalCode?: string;
location: _coordinates_numberArray_type_string_;
externalDeliveryService?: ExternalDeliveryService[];
            };
        

            export type Hours = {
                weekday: ScalarTypeMapWithCustom["Weekday"];
openedAt: string;
closedAt: string;
connectedWithNext?: boolean;
connectedWithPrev?: boolean;
            };
        

            export type Partial_SpecialHours_ = {
                date?: Date;
openedAt?: string;
closedAt?: string;
isClosed?: boolean;
            };
        

            export type _Duplicate1_Partial_SpecialHours_ = {
                date?: Date;
openedAt?: string;
closedAt?: string;
isClosed?: boolean;
            };
        

            export type DeliveryArea = {
                name: string;
description?: string;
fee?: ScalarTypeMapWithCustom["stringOrNumberDecimal"];
mov?: ScalarTypeMapWithCustom["stringOrNumberDecimal"];
location: Polygon;
            };
        

            export type Polygon = {
                type: Constant_Polygon;
coordinates?: Array<Array<Array<number>>>;
            };
        

            export type Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_ = {
                standard?: OrderOffset;
preorder?: _inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_;
catering?: _delivery_OrderOffset_takeAway_OrderOffset_;
terminal?: _inside_OrderOffset_takeAway_OrderOffset_;
            };
        

            export type OrderOffset = {
                first?: number;
offset?: number;
last?: number;
            };
        

            export type _inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_ = {
                inside: OrderOffset;
takeAway: OrderOffset;
delivery: OrderOffset;
            };
        

            export type _delivery_OrderOffset_takeAway_OrderOffset_ = {
                delivery: OrderOffset;
takeAway: OrderOffset;
            };
        

            export type _inside_OrderOffset_takeAway_OrderOffset_ = {
                inside: OrderOffset;
takeAway: OrderOffset;
            };
        

            export type Localization = {
                de?: string;
en?: string;
fr?: string;
nl?: string;
it?: string;
pl?: string;
es?: string;
zh?: string;
ru?: string;
tr?: string;
da?: string;
ja?: string;
is?: string;
pt?: string;
cz?: string;
cs?: string;
            };
        

            export type _coordinates_numberArray_type_string_ = {
                coordinates?: Array<number>;
type?: string;
            };
        

            export type ExternalDeliveryService = {
                image?: Assets;
link?: string;
name?: string;
            };
        

            export type Assets = {
                thumb: string;
medium: string;
large: string;
original: string;
            };
        

            export type Query = {
                mapsPoiVenues: (args: QueryMapsPoiVenuesArgs ) => MapsPoiVenue[];
            };
        
export interface EnumTypesMapped {
            "Currency": Currency,
"Constant_Polygon": Constant_Polygon,
        };

        type ReturnTypeFromHoursNotNullArraySelectionRetTypes<AS_PROMISE = 0> = {
        weekday: SelectionWrapperImpl<"weekday", "Weekday!", 0, {}, undefined>
openedAt: SelectionWrapperImpl<"openedAt", "String!", 0, {}, undefined>
closedAt: SelectionWrapperImpl<"closedAt", "String!", 0, {}, undefined>
connectedWithNext: SelectionWrapperImpl<"connectedWithNext", "Boolean", 0, {}, undefined>
connectedWithPrev: SelectionWrapperImpl<"connectedWithPrev", "Boolean", 0, {}, undefined>
        }
        type ReturnTypeFromHoursNotNullArraySelection = {
            weekday:  ReturnTypeFromHoursNotNullArraySelectionRetTypes["weekday"]
openedAt:  ReturnTypeFromHoursNotNullArraySelectionRetTypes["openedAt"]
closedAt:  ReturnTypeFromHoursNotNullArraySelectionRetTypes["closedAt"]
connectedWithNext:  ReturnTypeFromHoursNotNullArraySelectionRetTypes["connectedWithNext"]
connectedWithPrev:  ReturnTypeFromHoursNotNullArraySelectionRetTypes["connectedWithPrev"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeHoursNotNullArraySelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Hours[]>, "Hours[]">;
        };
            
            export function makeHoursNotNullArraySelectionInput(this: any) : ReturnTypeFromHoursNotNullArraySelection {
                return {
                    weekday: new SelectionWrapper(
            "weekday",
            "Weekday!",
            0,
            {},
            this,
            undefined,
            ),
openedAt: new SelectionWrapper(
            "openedAt",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
closedAt: new SelectionWrapper(
            "closedAt",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
connectedWithNext: new SelectionWrapper(
            "connectedWithNext",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
connectedWithPrev: new SelectionWrapper(
            "connectedWithPrev",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeHoursNotNullArraySelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeHoursNotNullArraySelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeHoursNotNullArraySelectionInput.bind(this)() as any,
                    "Hours[]",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const HoursNotNullArraySelection = makeSLFN(
                makeHoursNotNullArraySelectionInput,
                "HoursNotNullArraySelection",
                "Hours",
                1
            );
        
        

        type ReturnTypeFromPartial_SpecialHours_ArraySelectionRetTypes<AS_PROMISE = 0> = {
        date: SelectionWrapperImpl<"date", "Date", 0, {}, undefined>
openedAt: SelectionWrapperImpl<"openedAt", "String", 0, {}, undefined>
closedAt: SelectionWrapperImpl<"closedAt", "String", 0, {}, undefined>
isClosed: SelectionWrapperImpl<"isClosed", "Boolean", 0, {}, undefined>
        }
        type ReturnTypeFromPartial_SpecialHours_ArraySelection = {
            date:  ReturnTypeFromPartial_SpecialHours_ArraySelectionRetTypes["date"]
openedAt:  ReturnTypeFromPartial_SpecialHours_ArraySelectionRetTypes["openedAt"]
closedAt:  ReturnTypeFromPartial_SpecialHours_ArraySelectionRetTypes["closedAt"]
isClosed:  ReturnTypeFromPartial_SpecialHours_ArraySelectionRetTypes["isClosed"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makePartial_SpecialHours_ArraySelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Partial_SpecialHours_[]>, "Partial_SpecialHours_[]">;
        };
            
            export function makePartial_SpecialHours_ArraySelectionInput(this: any) : ReturnTypeFromPartial_SpecialHours_ArraySelection {
                return {
                    date: new SelectionWrapper(
            "date",
            "Date",
            0,
            {},
            this,
            undefined,
            ),
openedAt: new SelectionWrapper(
            "openedAt",
            "String",
            0,
            {},
            this,
            undefined,
            ),
closedAt: new SelectionWrapper(
            "closedAt",
            "String",
            0,
            {},
            this,
            undefined,
            ),
isClosed: new SelectionWrapper(
            "isClosed",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makePartial_SpecialHours_ArraySelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makePartial_SpecialHours_ArraySelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makePartial_SpecialHours_ArraySelectionInput.bind(this)() as any,
                    "Partial_SpecialHours_[]",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const Partial_SpecialHours_ArraySelection = makeSLFN(
                makePartial_SpecialHours_ArraySelectionInput,
                "Partial_SpecialHours_ArraySelection",
                "Partial_SpecialHours_",
                1
            );
        
        

        type ReturnTypeFrom_Duplicate1_Partial_SpecialHours_ArraySelectionRetTypes<AS_PROMISE = 0> = {
        date: SelectionWrapperImpl<"date", "Date", 0, {}, undefined>
openedAt: SelectionWrapperImpl<"openedAt", "String", 0, {}, undefined>
closedAt: SelectionWrapperImpl<"closedAt", "String", 0, {}, undefined>
isClosed: SelectionWrapperImpl<"isClosed", "Boolean", 0, {}, undefined>
        }
        type ReturnTypeFrom_Duplicate1_Partial_SpecialHours_ArraySelection = {
            date:  ReturnTypeFrom_Duplicate1_Partial_SpecialHours_ArraySelectionRetTypes["date"]
openedAt:  ReturnTypeFrom_Duplicate1_Partial_SpecialHours_ArraySelectionRetTypes["openedAt"]
closedAt:  ReturnTypeFrom_Duplicate1_Partial_SpecialHours_ArraySelectionRetTypes["closedAt"]
isClosed:  ReturnTypeFrom_Duplicate1_Partial_SpecialHours_ArraySelectionRetTypes["isClosed"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof make_Duplicate1_Partial_SpecialHours_ArraySelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<_Duplicate1_Partial_SpecialHours_[]>, "_Duplicate1_Partial_SpecialHours_[]">;
        };
            
            export function make_Duplicate1_Partial_SpecialHours_ArraySelectionInput(this: any) : ReturnTypeFrom_Duplicate1_Partial_SpecialHours_ArraySelection {
                return {
                    date: new SelectionWrapper(
            "date",
            "Date",
            0,
            {},
            this,
            undefined,
            ),
openedAt: new SelectionWrapper(
            "openedAt",
            "String",
            0,
            {},
            this,
            undefined,
            ),
closedAt: new SelectionWrapper(
            "closedAt",
            "String",
            0,
            {},
            this,
            undefined,
            ),
isClosed: new SelectionWrapper(
            "isClosed",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        make_Duplicate1_Partial_SpecialHours_ArraySelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof make_Duplicate1_Partial_SpecialHours_ArraySelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    make_Duplicate1_Partial_SpecialHours_ArraySelectionInput.bind(this)() as any,
                    "_Duplicate1_Partial_SpecialHours_[]",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const _Duplicate1_Partial_SpecialHours_ArraySelection = makeSLFN(
                make_Duplicate1_Partial_SpecialHours_ArraySelectionInput,
                "_Duplicate1_Partial_SpecialHours_ArraySelection",
                "_Duplicate1_Partial_SpecialHours_",
                1
            );
        
        

        type ReturnTypeFromDeliveryAreaNotNullArraySelectionRetTypes<AS_PROMISE = 0> = {
        name: SelectionWrapperImpl<"name", "String!", 0, {}, undefined>
description: SelectionWrapperImpl<"description", "String", 0, {}, undefined>
fee: SelectionWrapperImpl<"fee", "stringOrNumberDecimal", 0, {}, undefined>
mov: SelectionWrapperImpl<"mov", "stringOrNumberDecimal", 0, {}, undefined>
location: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makePolygonNotNullSelectionInput>,
                                                "PolygonNotNullSelection",
                                                "Polygon",
                                                0
                                                
                                            >
                                        >
        }
        type ReturnTypeFromDeliveryAreaNotNullArraySelection = {
            name:  ReturnTypeFromDeliveryAreaNotNullArraySelectionRetTypes["name"]
description:  ReturnTypeFromDeliveryAreaNotNullArraySelectionRetTypes["description"]
fee:  ReturnTypeFromDeliveryAreaNotNullArraySelectionRetTypes["fee"]
mov:  ReturnTypeFromDeliveryAreaNotNullArraySelectionRetTypes["mov"]
location:  ReturnTypeFromDeliveryAreaNotNullArraySelectionRetTypes["location"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeDeliveryAreaNotNullArraySelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<DeliveryArea[]>, "DeliveryArea[]">;
        };
            
            export function makeDeliveryAreaNotNullArraySelectionInput(this: any) : ReturnTypeFromDeliveryAreaNotNullArraySelection {
                return {
                    name: new SelectionWrapper(
            "name",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
description: new SelectionWrapper(
            "description",
            "String",
            0,
            {},
            this,
            undefined,
            ),
fee: new SelectionWrapper(
            "fee",
            "stringOrNumberDecimal",
            0,
            {},
            this,
            undefined,
            ),
mov: new SelectionWrapper(
            "mov",
            "stringOrNumberDecimal",
            0,
            {},
            this,
            undefined,
            ),
location: PolygonNotNullSelection.bind({ collector: this, fieldName: "location" }),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeDeliveryAreaNotNullArraySelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeDeliveryAreaNotNullArraySelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeDeliveryAreaNotNullArraySelectionInput.bind(this)() as any,
                    "DeliveryArea[]",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const DeliveryAreaNotNullArraySelection = makeSLFN(
                makeDeliveryAreaNotNullArraySelectionInput,
                "DeliveryAreaNotNullArraySelection",
                "DeliveryArea",
                1
            );
        
        

        type ReturnTypeFromPolygonNotNullSelectionRetTypes<AS_PROMISE = 0> = {
        type: SelectionWrapperImpl<"type", "Constant_Polygon!", 0, {}, undefined>
coordinates: SelectionWrapperImpl<"coordinates", "Float", 3, {}, undefined>
        }
        type ReturnTypeFromPolygonNotNullSelection = {
            type:  ReturnTypeFromPolygonNotNullSelectionRetTypes["type"]
coordinates:  ReturnTypeFromPolygonNotNullSelectionRetTypes["coordinates"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makePolygonNotNullSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Polygon>, "Polygon">;
        };
            
            export function makePolygonNotNullSelectionInput(this: any) : ReturnTypeFromPolygonNotNullSelection {
                return {
                    type: new SelectionWrapper(
            "type",
            "Constant_Polygon!",
            0,
            {},
            this,
            undefined,
            ),
coordinates: new SelectionWrapper(
            "coordinates",
            "Float",
            3,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makePolygonNotNullSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makePolygonNotNullSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makePolygonNotNullSelectionInput.bind(this)() as any,
                    "Polygon",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const PolygonNotNullSelection = makeSLFN(
                makePolygonNotNullSelectionInput,
                "PolygonNotNullSelection",
                "Polygon",
                0
            );
        
        

        type ReturnTypeFromPartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_SelectionRetTypes<AS_PROMISE = 0> = {
        standard: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeOrderOffsetSelectionInput>,
                                                "OrderOffsetSelection",
                                                "OrderOffset",
                                                0
                                                
                                            >
                                        >
preorder: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof make_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_SelectionInput>,
                                                "_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_Selection",
                                                "_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_",
                                                0
                                                
                                            >
                                        >
catering: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof make_delivery_OrderOffset_takeAway_OrderOffset_SelectionInput>,
                                                "_delivery_OrderOffset_takeAway_OrderOffset_Selection",
                                                "_delivery_OrderOffset_takeAway_OrderOffset_",
                                                0
                                                
                                            >
                                        >
terminal: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof make_inside_OrderOffset_takeAway_OrderOffset_SelectionInput>,
                                                "_inside_OrderOffset_takeAway_OrderOffset_Selection",
                                                "_inside_OrderOffset_takeAway_OrderOffset_",
                                                0
                                                
                                            >
                                        >
        }
        type ReturnTypeFromPartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_Selection = {
            standard:  ReturnTypeFromPartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_SelectionRetTypes["standard"]
preorder:  ReturnTypeFromPartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_SelectionRetTypes["preorder"]
catering:  ReturnTypeFromPartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_SelectionRetTypes["catering"]
terminal:  ReturnTypeFromPartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_SelectionRetTypes["terminal"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_>, "Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_">;
        };
            
            export function makePartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_SelectionInput(this: any) : ReturnTypeFromPartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_Selection {
                return {
                    standard: OrderOffsetSelection.bind({ collector: this, fieldName: "standard" }),
preorder: _inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_Selection.bind({ collector: this, fieldName: "preorder" }),
catering: _delivery_OrderOffset_takeAway_OrderOffset_Selection.bind({ collector: this, fieldName: "catering" }),
terminal: _inside_OrderOffset_takeAway_OrderOffset_Selection.bind({ collector: this, fieldName: "terminal" }),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makePartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_SelectionInput.bind(this)() as any,
                    "Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_Selection = makeSLFN(
                makePartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_SelectionInput,
                "Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_Selection",
                "Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_",
                0
            );
        
        

        type ReturnTypeFromOrderOffsetSelectionRetTypes<AS_PROMISE = 0> = {
        first: SelectionWrapperImpl<"first", "Float", 0, {}, undefined>
offset: SelectionWrapperImpl<"offset", "Float", 0, {}, undefined>
last: SelectionWrapperImpl<"last", "Float", 0, {}, undefined>
        }
        type ReturnTypeFromOrderOffsetSelection = {
            first:  ReturnTypeFromOrderOffsetSelectionRetTypes["first"]
offset:  ReturnTypeFromOrderOffsetSelectionRetTypes["offset"]
last:  ReturnTypeFromOrderOffsetSelectionRetTypes["last"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeOrderOffsetSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<OrderOffset>, "OrderOffset">;
        };
            
            export function makeOrderOffsetSelectionInput(this: any) : ReturnTypeFromOrderOffsetSelection {
                return {
                    first: new SelectionWrapper(
            "first",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
offset: new SelectionWrapper(
            "offset",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
last: new SelectionWrapper(
            "last",
            "Float",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeOrderOffsetSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeOrderOffsetSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeOrderOffsetSelectionInput.bind(this)() as any,
                    "OrderOffset",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const OrderOffsetSelection = makeSLFN(
                makeOrderOffsetSelectionInput,
                "OrderOffsetSelection",
                "OrderOffset",
                0
            );
        
        

        type ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_SelectionRetTypes<AS_PROMISE = 0> = {
        inside: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeOrderOffsetNotNullSelectionInput>,
                                                "OrderOffsetNotNullSelection",
                                                "OrderOffset",
                                                0
                                                
                                            >
                                        >
takeAway: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeOrderOffsetNotNullSelectionInput>,
                                                "OrderOffsetNotNullSelection",
                                                "OrderOffset",
                                                0
                                                
                                            >
                                        >
delivery: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeOrderOffsetNotNullSelectionInput>,
                                                "OrderOffsetNotNullSelection",
                                                "OrderOffset",
                                                0
                                                
                                            >
                                        >
        }
        type ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_Selection = {
            inside:  ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_SelectionRetTypes["inside"]
takeAway:  ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_SelectionRetTypes["takeAway"]
delivery:  ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_SelectionRetTypes["delivery"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_>, "_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_">;
        };
            
            export function make_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_SelectionInput(this: any) : ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_Selection {
                return {
                    inside: OrderOffsetNotNullSelection.bind({ collector: this, fieldName: "inside" }),
takeAway: OrderOffsetNotNullSelection.bind({ collector: this, fieldName: "takeAway" }),
delivery: OrderOffsetNotNullSelection.bind({ collector: this, fieldName: "delivery" }),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    make_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_SelectionInput.bind(this)() as any,
                    "_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const _inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_Selection = makeSLFN(
                make_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_SelectionInput,
                "_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_Selection",
                "_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_",
                0
            );
        
        

        type ReturnTypeFromOrderOffsetNotNullSelectionRetTypes<AS_PROMISE = 0> = {
        first: SelectionWrapperImpl<"first", "Float", 0, {}, undefined>
offset: SelectionWrapperImpl<"offset", "Float", 0, {}, undefined>
last: SelectionWrapperImpl<"last", "Float", 0, {}, undefined>
        }
        type ReturnTypeFromOrderOffsetNotNullSelection = {
            first:  ReturnTypeFromOrderOffsetNotNullSelectionRetTypes["first"]
offset:  ReturnTypeFromOrderOffsetNotNullSelectionRetTypes["offset"]
last:  ReturnTypeFromOrderOffsetNotNullSelectionRetTypes["last"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeOrderOffsetNotNullSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<OrderOffset>, "OrderOffset">;
        };
            
            export function makeOrderOffsetNotNullSelectionInput(this: any) : ReturnTypeFromOrderOffsetNotNullSelection {
                return {
                    first: new SelectionWrapper(
            "first",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
offset: new SelectionWrapper(
            "offset",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
last: new SelectionWrapper(
            "last",
            "Float",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeOrderOffsetNotNullSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeOrderOffsetNotNullSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeOrderOffsetNotNullSelectionInput.bind(this)() as any,
                    "OrderOffset",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const OrderOffsetNotNullSelection = makeSLFN(
                makeOrderOffsetNotNullSelectionInput,
                "OrderOffsetNotNullSelection",
                "OrderOffset",
                0
            );
        
        

        type ReturnTypeFrom_delivery_OrderOffset_takeAway_OrderOffset_SelectionRetTypes<AS_PROMISE = 0> = {
        delivery: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeOrderOffsetNotNullSelectionInput>,
                                                "OrderOffsetNotNullSelection",
                                                "OrderOffset",
                                                0
                                                
                                            >
                                        >
takeAway: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeOrderOffsetNotNullSelectionInput>,
                                                "OrderOffsetNotNullSelection",
                                                "OrderOffset",
                                                0
                                                
                                            >
                                        >
        }
        type ReturnTypeFrom_delivery_OrderOffset_takeAway_OrderOffset_Selection = {
            delivery:  ReturnTypeFrom_delivery_OrderOffset_takeAway_OrderOffset_SelectionRetTypes["delivery"]
takeAway:  ReturnTypeFrom_delivery_OrderOffset_takeAway_OrderOffset_SelectionRetTypes["takeAway"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<_delivery_OrderOffset_takeAway_OrderOffset_>, "_delivery_OrderOffset_takeAway_OrderOffset_">;
        };
            
            export function make_delivery_OrderOffset_takeAway_OrderOffset_SelectionInput(this: any) : ReturnTypeFrom_delivery_OrderOffset_takeAway_OrderOffset_Selection {
                return {
                    delivery: OrderOffsetNotNullSelection.bind({ collector: this, fieldName: "delivery" }),
takeAway: OrderOffsetNotNullSelection.bind({ collector: this, fieldName: "takeAway" }),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    make_delivery_OrderOffset_takeAway_OrderOffset_SelectionInput.bind(this)() as any,
                    "_delivery_OrderOffset_takeAway_OrderOffset_",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const _delivery_OrderOffset_takeAway_OrderOffset_Selection = makeSLFN(
                make_delivery_OrderOffset_takeAway_OrderOffset_SelectionInput,
                "_delivery_OrderOffset_takeAway_OrderOffset_Selection",
                "_delivery_OrderOffset_takeAway_OrderOffset_",
                0
            );
        
        

        type ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_SelectionRetTypes<AS_PROMISE = 0> = {
        inside: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeOrderOffsetNotNullSelectionInput>,
                                                "OrderOffsetNotNullSelection",
                                                "OrderOffset",
                                                0
                                                
                                            >
                                        >
takeAway: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeOrderOffsetNotNullSelectionInput>,
                                                "OrderOffsetNotNullSelection",
                                                "OrderOffset",
                                                0
                                                
                                            >
                                        >
        }
        type ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_Selection = {
            inside:  ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_SelectionRetTypes["inside"]
takeAway:  ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_SelectionRetTypes["takeAway"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<_inside_OrderOffset_takeAway_OrderOffset_>, "_inside_OrderOffset_takeAway_OrderOffset_">;
        };
            
            export function make_inside_OrderOffset_takeAway_OrderOffset_SelectionInput(this: any) : ReturnTypeFrom_inside_OrderOffset_takeAway_OrderOffset_Selection {
                return {
                    inside: OrderOffsetNotNullSelection.bind({ collector: this, fieldName: "inside" }),
takeAway: OrderOffsetNotNullSelection.bind({ collector: this, fieldName: "takeAway" }),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    make_inside_OrderOffset_takeAway_OrderOffset_SelectionInput.bind(this)() as any,
                    "_inside_OrderOffset_takeAway_OrderOffset_",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const _inside_OrderOffset_takeAway_OrderOffset_Selection = makeSLFN(
                make_inside_OrderOffset_takeAway_OrderOffset_SelectionInput,
                "_inside_OrderOffset_takeAway_OrderOffset_Selection",
                "_inside_OrderOffset_takeAway_OrderOffset_",
                0
            );
        
        

        type ReturnTypeFromLocalizationNotNullSelectionRetTypes<AS_PROMISE = 0> = {
        de: SelectionWrapperImpl<"de", "String", 0, {}, undefined>
en: SelectionWrapperImpl<"en", "String", 0, {}, undefined>
fr: SelectionWrapperImpl<"fr", "String", 0, {}, undefined>
nl: SelectionWrapperImpl<"nl", "String", 0, {}, undefined>
it: SelectionWrapperImpl<"it", "String", 0, {}, undefined>
pl: SelectionWrapperImpl<"pl", "String", 0, {}, undefined>
es: SelectionWrapperImpl<"es", "String", 0, {}, undefined>
zh: SelectionWrapperImpl<"zh", "String", 0, {}, undefined>
ru: SelectionWrapperImpl<"ru", "String", 0, {}, undefined>
tr: SelectionWrapperImpl<"tr", "String", 0, {}, undefined>
da: SelectionWrapperImpl<"da", "String", 0, {}, undefined>
ja: SelectionWrapperImpl<"ja", "String", 0, {}, undefined>
is: SelectionWrapperImpl<"is", "String", 0, {}, undefined>
pt: SelectionWrapperImpl<"pt", "String", 0, {}, undefined>
cz: SelectionWrapperImpl<"cz", "String", 0, {}, undefined>
cs: SelectionWrapperImpl<"cs", "String", 0, {}, undefined>
        }
        type ReturnTypeFromLocalizationNotNullSelection = {
            de:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["de"]
en:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["en"]
fr:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["fr"]
nl:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["nl"]
it:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["it"]
pl:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["pl"]
es:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["es"]
zh:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["zh"]
ru:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["ru"]
tr:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["tr"]
da:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["da"]
ja:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["ja"]
is:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["is"]
pt:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["pt"]
cz:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["cz"]
cs:  ReturnTypeFromLocalizationNotNullSelectionRetTypes["cs"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeLocalizationNotNullSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Localization>, "Localization">;
        };
            
            export function makeLocalizationNotNullSelectionInput(this: any) : ReturnTypeFromLocalizationNotNullSelection {
                return {
                    de: new SelectionWrapper(
            "de",
            "String",
            0,
            {},
            this,
            undefined,
            ),
en: new SelectionWrapper(
            "en",
            "String",
            0,
            {},
            this,
            undefined,
            ),
fr: new SelectionWrapper(
            "fr",
            "String",
            0,
            {},
            this,
            undefined,
            ),
nl: new SelectionWrapper(
            "nl",
            "String",
            0,
            {},
            this,
            undefined,
            ),
it: new SelectionWrapper(
            "it",
            "String",
            0,
            {},
            this,
            undefined,
            ),
pl: new SelectionWrapper(
            "pl",
            "String",
            0,
            {},
            this,
            undefined,
            ),
es: new SelectionWrapper(
            "es",
            "String",
            0,
            {},
            this,
            undefined,
            ),
zh: new SelectionWrapper(
            "zh",
            "String",
            0,
            {},
            this,
            undefined,
            ),
ru: new SelectionWrapper(
            "ru",
            "String",
            0,
            {},
            this,
            undefined,
            ),
tr: new SelectionWrapper(
            "tr",
            "String",
            0,
            {},
            this,
            undefined,
            ),
da: new SelectionWrapper(
            "da",
            "String",
            0,
            {},
            this,
            undefined,
            ),
ja: new SelectionWrapper(
            "ja",
            "String",
            0,
            {},
            this,
            undefined,
            ),
is: new SelectionWrapper(
            "is",
            "String",
            0,
            {},
            this,
            undefined,
            ),
pt: new SelectionWrapper(
            "pt",
            "String",
            0,
            {},
            this,
            undefined,
            ),
cz: new SelectionWrapper(
            "cz",
            "String",
            0,
            {},
            this,
            undefined,
            ),
cs: new SelectionWrapper(
            "cs",
            "String",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeLocalizationNotNullSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeLocalizationNotNullSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeLocalizationNotNullSelectionInput.bind(this)() as any,
                    "Localization",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const LocalizationNotNullSelection = makeSLFN(
                makeLocalizationNotNullSelectionInput,
                "LocalizationNotNullSelection",
                "Localization",
                0
            );
        
        

        type ReturnTypeFrom_coordinates_numberArray_type_string_NotNullSelectionRetTypes<AS_PROMISE = 0> = {
        coordinates: SelectionWrapperImpl<"coordinates", "Float", 1, {}, undefined>
type: SelectionWrapperImpl<"type", "String", 0, {}, undefined>
        }
        type ReturnTypeFrom_coordinates_numberArray_type_string_NotNullSelection = {
            coordinates:  ReturnTypeFrom_coordinates_numberArray_type_string_NotNullSelectionRetTypes["coordinates"]
type:  ReturnTypeFrom_coordinates_numberArray_type_string_NotNullSelectionRetTypes["type"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof make_coordinates_numberArray_type_string_NotNullSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<_coordinates_numberArray_type_string_>, "_coordinates_numberArray_type_string_">;
        };
            
            export function make_coordinates_numberArray_type_string_NotNullSelectionInput(this: any) : ReturnTypeFrom_coordinates_numberArray_type_string_NotNullSelection {
                return {
                    coordinates: new SelectionWrapper(
            "coordinates",
            "Float",
            1,
            {},
            this,
            undefined,
            ),
type: new SelectionWrapper(
            "type",
            "String",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        make_coordinates_numberArray_type_string_NotNullSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof make_coordinates_numberArray_type_string_NotNullSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    make_coordinates_numberArray_type_string_NotNullSelectionInput.bind(this)() as any,
                    "_coordinates_numberArray_type_string_",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const _coordinates_numberArray_type_string_NotNullSelection = makeSLFN(
                make_coordinates_numberArray_type_string_NotNullSelectionInput,
                "_coordinates_numberArray_type_string_NotNullSelection",
                "_coordinates_numberArray_type_string_",
                0
            );
        
        

        type ReturnTypeFromExternalDeliveryServiceNotNullArraySelectionRetTypes<AS_PROMISE = 0> = {
        image: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeAssetsSelectionInput>,
                                                "AssetsSelection",
                                                "Assets",
                                                0
                                                
                                            >
                                        >
link: SelectionWrapperImpl<"link", "String", 0, {}, undefined>
name: SelectionWrapperImpl<"name", "String", 0, {}, undefined>
        }
        type ReturnTypeFromExternalDeliveryServiceNotNullArraySelection = {
            image:  ReturnTypeFromExternalDeliveryServiceNotNullArraySelectionRetTypes["image"]
link:  ReturnTypeFromExternalDeliveryServiceNotNullArraySelectionRetTypes["link"]
name:  ReturnTypeFromExternalDeliveryServiceNotNullArraySelectionRetTypes["name"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeExternalDeliveryServiceNotNullArraySelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<ExternalDeliveryService[]>, "ExternalDeliveryService[]">;
        };
            
            export function makeExternalDeliveryServiceNotNullArraySelectionInput(this: any) : ReturnTypeFromExternalDeliveryServiceNotNullArraySelection {
                return {
                    image: AssetsSelection.bind({ collector: this, fieldName: "image" }),
link: new SelectionWrapper(
            "link",
            "String",
            0,
            {},
            this,
            undefined,
            ),
name: new SelectionWrapper(
            "name",
            "String",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeExternalDeliveryServiceNotNullArraySelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeExternalDeliveryServiceNotNullArraySelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeExternalDeliveryServiceNotNullArraySelectionInput.bind(this)() as any,
                    "ExternalDeliveryService[]",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const ExternalDeliveryServiceNotNullArraySelection = makeSLFN(
                makeExternalDeliveryServiceNotNullArraySelectionInput,
                "ExternalDeliveryServiceNotNullArraySelection",
                "ExternalDeliveryService",
                1
            );
        
        

        type ReturnTypeFromAssetsSelectionRetTypes<AS_PROMISE = 0> = {
        thumb: SelectionWrapperImpl<"thumb", "String!", 0, {}, undefined>
medium: SelectionWrapperImpl<"medium", "String!", 0, {}, undefined>
large: SelectionWrapperImpl<"large", "String!", 0, {}, undefined>
original: SelectionWrapperImpl<"original", "String!", 0, {}, undefined>
        }
        type ReturnTypeFromAssetsSelection = {
            thumb:  ReturnTypeFromAssetsSelectionRetTypes["thumb"]
medium:  ReturnTypeFromAssetsSelectionRetTypes["medium"]
large:  ReturnTypeFromAssetsSelectionRetTypes["large"]
original:  ReturnTypeFromAssetsSelectionRetTypes["original"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeAssetsSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Assets>, "Assets">;
        };
            
            export function makeAssetsSelectionInput(this: any) : ReturnTypeFromAssetsSelection {
                return {
                    thumb: new SelectionWrapper(
            "thumb",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
medium: new SelectionWrapper(
            "medium",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
large: new SelectionWrapper(
            "large",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
original: new SelectionWrapper(
            "original",
            "String!",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeAssetsSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeAssetsSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeAssetsSelectionInput.bind(this)() as any,
                    "Assets",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const AssetsSelection = makeSLFN(
                makeAssetsSelectionInput,
                "AssetsSelection",
                "Assets",
                0
            );
        
        

        type ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes<AS_PROMISE = 0> = {
        _id: SelectionWrapperImpl<"_id", "String!", 0, {}, undefined>
readableId: SelectionWrapperImpl<"readableId", "String", 0, {}, undefined>
name: SelectionWrapperImpl<"name", "String!", 0, {}, undefined>
isPublished: SelectionWrapperImpl<"isPublished", "Boolean", 0, {}, undefined>
isServiceActivated: SelectionWrapperImpl<"isServiceActivated", "Boolean", 0, {}, undefined>
currency: SelectionWrapperImpl<"currency", "Currency!", 0, {}, undefined>
preorderTable: SelectionWrapperImpl<"preorderTable", "String", 0, {}, undefined>
openingHours: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeHoursNotNullArraySelectionInput>,
                                                "HoursNotNullArraySelection",
                                                "Hours",
                                                1
                                                
                                            >
                                        >
deliveryHours: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeHoursNotNullArraySelectionInput>,
                                                "HoursNotNullArraySelection",
                                                "Hours",
                                                1
                                                
                                            >
                                        >
specialOpeningHours: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makePartial_SpecialHours_ArraySelectionInput>,
                                                "Partial_SpecialHours_ArraySelection",
                                                "Partial_SpecialHours_",
                                                1
                                                
                                            >
                                        >
specialDeliveryHours: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof make_Duplicate1_Partial_SpecialHours_ArraySelectionInput>,
                                                "_Duplicate1_Partial_SpecialHours_ArraySelection",
                                                "_Duplicate1_Partial_SpecialHours_",
                                                1
                                                
                                            >
                                        >
cateringHoursTakeAway: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeHoursNotNullArraySelectionInput>,
                                                "HoursNotNullArraySelection",
                                                "Hours",
                                                1
                                                
                                            >
                                        >
panicEndAt: SelectionWrapperImpl<"panicEndAt", "Date", 0, {}, undefined>
preorderTakeAway: SelectionWrapperImpl<"preorderTakeAway", "Boolean!", 0, {}, undefined>
preorderIn: SelectionWrapperImpl<"preorderIn", "Boolean!", 0, {}, undefined>
deliveryEnabled: SelectionWrapperImpl<"deliveryEnabled", "Boolean", 0, {}, undefined>
deliveryByAreas: SelectionWrapperImpl<"deliveryByAreas", "Boolean", 0, {}, undefined>
deliveryByRadius: SelectionWrapperImpl<"deliveryByRadius", "Boolean", 0, {}, undefined>
isPostalDelivery: SelectionWrapperImpl<"isPostalDelivery", "Boolean", 0, {}, undefined>
deliveryAreas: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeDeliveryAreaNotNullArraySelectionInput>,
                                                "DeliveryAreaNotNullArraySelection",
                                                "DeliveryArea",
                                                1
                                                
                                            >
                                        >
deliveryPostalCodes: SelectionWrapperImpl<"deliveryPostalCodes", "String", 1, {}, undefined>
deliveryRadius: SelectionWrapperImpl<"deliveryRadius", "Float", 0, {}, undefined>
distance: SelectionWrapperImpl<"distance", "Float", 0, {}, undefined>
cateringTakeAway: SelectionWrapperImpl<"cateringTakeAway", "Boolean", 0, {}, undefined>
cateringDelivery: SelectionWrapperImpl<"cateringDelivery", "Boolean", 0, {}, undefined>
offsets: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makePartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_SelectionInput>,
                                                "Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_Selection",
                                                "Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_",
                                                0
                                                
                                            >
                                        >
firstPreorderOffset: SelectionWrapperImpl<"firstPreorderOffset", "Float", 0, {}, undefined>
preorderOffset: SelectionWrapperImpl<"preorderOffset", "Float", 0, {}, undefined>
lastPreorderOffset: SelectionWrapperImpl<"lastPreorderOffset", "Float", 0, {}, undefined>
city: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeLocalizationNotNullSelectionInput>,
                                                "LocalizationNotNullSelection",
                                                "Localization",
                                                0
                                                
                                            >
                                        >
street: SelectionWrapperImpl<"street", "String", 0, {}, undefined>
number: SelectionWrapperImpl<"number", "String", 0, {}, undefined>
phoneNumber: SelectionWrapperImpl<"phoneNumber", "String", 0, {}, undefined>
address: SelectionWrapperImpl<"address", "String", 0, {}, undefined>
country: SelectionWrapperImpl<"country", "String!", 0, {}, undefined>
website: SelectionWrapperImpl<"website", "String", 0, {}, undefined>
postalCode: SelectionWrapperImpl<"postalCode", "String", 0, {}, undefined>
location: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof make_coordinates_numberArray_type_string_NotNullSelectionInput>,
                                                "_coordinates_numberArray_type_string_NotNullSelection",
                                                "_coordinates_numberArray_type_string_",
                                                0
                                                
                                            >
                                        >
externalDeliveryService: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeExternalDeliveryServiceNotNullArraySelectionInput>,
                                                "ExternalDeliveryServiceNotNullArraySelection",
                                                "ExternalDeliveryService",
                                                1
                                                
                                            >
                                        >
        }
        type ReturnTypeFromMapsPoiVenueNotNullArraySelection = {
            _id:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["_id"]
readableId:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["readableId"]
name:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["name"]
isPublished:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["isPublished"]
isServiceActivated:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["isServiceActivated"]
currency:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["currency"]
preorderTable:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["preorderTable"]
openingHours:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["openingHours"]
deliveryHours:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["deliveryHours"]
specialOpeningHours:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["specialOpeningHours"]
specialDeliveryHours:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["specialDeliveryHours"]
cateringHoursTakeAway:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["cateringHoursTakeAway"]
panicEndAt:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["panicEndAt"]
preorderTakeAway:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["preorderTakeAway"]
preorderIn:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["preorderIn"]
deliveryEnabled:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["deliveryEnabled"]
deliveryByAreas:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["deliveryByAreas"]
deliveryByRadius:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["deliveryByRadius"]
isPostalDelivery:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["isPostalDelivery"]
deliveryAreas:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["deliveryAreas"]
deliveryPostalCodes:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["deliveryPostalCodes"]
deliveryRadius:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["deliveryRadius"]
distance:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["distance"]
cateringTakeAway:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["cateringTakeAway"]
cateringDelivery:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["cateringDelivery"]
offsets:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["offsets"]
firstPreorderOffset:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["firstPreorderOffset"]
preorderOffset:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["preorderOffset"]
lastPreorderOffset:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["lastPreorderOffset"]
city:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["city"]
street:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["street"]
number:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["number"]
phoneNumber:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["phoneNumber"]
address:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["address"]
country:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["country"]
website:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["website"]
postalCode:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["postalCode"]
location:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["location"]
externalDeliveryService:  ReturnTypeFromMapsPoiVenueNotNullArraySelectionRetTypes["externalDeliveryService"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeMapsPoiVenueNotNullArraySelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<MapsPoiVenue[]>, "MapsPoiVenue[]">;
        };
            
            export function makeMapsPoiVenueNotNullArraySelectionInput(this: any) : ReturnTypeFromMapsPoiVenueNotNullArraySelection {
                return {
                    _id: new SelectionWrapper(
            "_id",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
readableId: new SelectionWrapper(
            "readableId",
            "String",
            0,
            {},
            this,
            undefined,
            ),
name: new SelectionWrapper(
            "name",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
isPublished: new SelectionWrapper(
            "isPublished",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
isServiceActivated: new SelectionWrapper(
            "isServiceActivated",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
currency: new SelectionWrapper(
            "currency",
            "Currency!",
            0,
            {},
            this,
            undefined,
            ),
preorderTable: new SelectionWrapper(
            "preorderTable",
            "String",
            0,
            {},
            this,
            undefined,
            ),
openingHours: HoursNotNullArraySelection.bind({ collector: this, fieldName: "openingHours" }),
deliveryHours: HoursNotNullArraySelection.bind({ collector: this, fieldName: "deliveryHours" }),
specialOpeningHours: Partial_SpecialHours_ArraySelection.bind({ collector: this, fieldName: "specialOpeningHours" }),
specialDeliveryHours: _Duplicate1_Partial_SpecialHours_ArraySelection.bind({ collector: this, fieldName: "specialDeliveryHours" }),
cateringHoursTakeAway: HoursNotNullArraySelection.bind({ collector: this, fieldName: "cateringHoursTakeAway" }),
panicEndAt: new SelectionWrapper(
            "panicEndAt",
            "Date",
            0,
            {},
            this,
            undefined,
            ),
preorderTakeAway: new SelectionWrapper(
            "preorderTakeAway",
            "Boolean!",
            0,
            {},
            this,
            undefined,
            ),
preorderIn: new SelectionWrapper(
            "preorderIn",
            "Boolean!",
            0,
            {},
            this,
            undefined,
            ),
deliveryEnabled: new SelectionWrapper(
            "deliveryEnabled",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
deliveryByAreas: new SelectionWrapper(
            "deliveryByAreas",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
deliveryByRadius: new SelectionWrapper(
            "deliveryByRadius",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
isPostalDelivery: new SelectionWrapper(
            "isPostalDelivery",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
deliveryAreas: DeliveryAreaNotNullArraySelection.bind({ collector: this, fieldName: "deliveryAreas" }),
deliveryPostalCodes: new SelectionWrapper(
            "deliveryPostalCodes",
            "String",
            1,
            {},
            this,
            undefined,
            ),
deliveryRadius: new SelectionWrapper(
            "deliveryRadius",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
distance: new SelectionWrapper(
            "distance",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
cateringTakeAway: new SelectionWrapper(
            "cateringTakeAway",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
cateringDelivery: new SelectionWrapper(
            "cateringDelivery",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
offsets: Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_Selection.bind({ collector: this, fieldName: "offsets" }),
firstPreorderOffset: new SelectionWrapper(
            "firstPreorderOffset",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
preorderOffset: new SelectionWrapper(
            "preorderOffset",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
lastPreorderOffset: new SelectionWrapper(
            "lastPreorderOffset",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
city: LocalizationNotNullSelection.bind({ collector: this, fieldName: "city" }),
street: new SelectionWrapper(
            "street",
            "String",
            0,
            {},
            this,
            undefined,
            ),
number: new SelectionWrapper(
            "number",
            "String",
            0,
            {},
            this,
            undefined,
            ),
phoneNumber: new SelectionWrapper(
            "phoneNumber",
            "String",
            0,
            {},
            this,
            undefined,
            ),
address: new SelectionWrapper(
            "address",
            "String",
            0,
            {},
            this,
            undefined,
            ),
country: new SelectionWrapper(
            "country",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
website: new SelectionWrapper(
            "website",
            "String",
            0,
            {},
            this,
            undefined,
            ),
postalCode: new SelectionWrapper(
            "postalCode",
            "String",
            0,
            {},
            this,
            undefined,
            ),
location: _coordinates_numberArray_type_string_NotNullSelection.bind({ collector: this, fieldName: "location" }),
externalDeliveryService: ExternalDeliveryServiceNotNullArraySelection.bind({ collector: this, fieldName: "externalDeliveryService" }),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeMapsPoiVenueNotNullArraySelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeMapsPoiVenueNotNullArraySelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeMapsPoiVenueNotNullArraySelectionInput.bind(this)() as any,
                    "MapsPoiVenue[]",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const MapsPoiVenueNotNullArraySelection = makeSLFN(
                makeMapsPoiVenueNotNullArraySelectionInput,
                "MapsPoiVenueNotNullArraySelection",
                "MapsPoiVenue",
                1
            );
        
        

        type ReturnTypeFromHoursSelectionRetTypes<AS_PROMISE = 0> = {
        weekday: SelectionWrapperImpl<"weekday", "Weekday!", 0, {}, undefined>
openedAt: SelectionWrapperImpl<"openedAt", "String!", 0, {}, undefined>
closedAt: SelectionWrapperImpl<"closedAt", "String!", 0, {}, undefined>
connectedWithNext: SelectionWrapperImpl<"connectedWithNext", "Boolean", 0, {}, undefined>
connectedWithPrev: SelectionWrapperImpl<"connectedWithPrev", "Boolean", 0, {}, undefined>
        }
        type ReturnTypeFromHoursSelection = {
            weekday:  ReturnTypeFromHoursSelectionRetTypes["weekday"]
openedAt:  ReturnTypeFromHoursSelectionRetTypes["openedAt"]
closedAt:  ReturnTypeFromHoursSelectionRetTypes["closedAt"]
connectedWithNext:  ReturnTypeFromHoursSelectionRetTypes["connectedWithNext"]
connectedWithPrev:  ReturnTypeFromHoursSelectionRetTypes["connectedWithPrev"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeHoursSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Hours>, "Hours">;
        };
            
            export function makeHoursSelectionInput(this: any) : ReturnTypeFromHoursSelection {
                return {
                    weekday: new SelectionWrapper(
            "weekday",
            "Weekday!",
            0,
            {},
            this,
            undefined,
            ),
openedAt: new SelectionWrapper(
            "openedAt",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
closedAt: new SelectionWrapper(
            "closedAt",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
connectedWithNext: new SelectionWrapper(
            "connectedWithNext",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
connectedWithPrev: new SelectionWrapper(
            "connectedWithPrev",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeHoursSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeHoursSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeHoursSelectionInput.bind(this)() as any,
                    "Hours",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const HoursSelection = makeSLFN(
                makeHoursSelectionInput,
                "HoursSelection",
                "Hours",
                0
            );
        
        

        type ReturnTypeFromPartial_SpecialHours_SelectionRetTypes<AS_PROMISE = 0> = {
        date: SelectionWrapperImpl<"date", "Date", 0, {}, undefined>
openedAt: SelectionWrapperImpl<"openedAt", "String", 0, {}, undefined>
closedAt: SelectionWrapperImpl<"closedAt", "String", 0, {}, undefined>
isClosed: SelectionWrapperImpl<"isClosed", "Boolean", 0, {}, undefined>
        }
        type ReturnTypeFromPartial_SpecialHours_Selection = {
            date:  ReturnTypeFromPartial_SpecialHours_SelectionRetTypes["date"]
openedAt:  ReturnTypeFromPartial_SpecialHours_SelectionRetTypes["openedAt"]
closedAt:  ReturnTypeFromPartial_SpecialHours_SelectionRetTypes["closedAt"]
isClosed:  ReturnTypeFromPartial_SpecialHours_SelectionRetTypes["isClosed"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makePartial_SpecialHours_SelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Partial_SpecialHours_>, "Partial_SpecialHours_">;
        };
            
            export function makePartial_SpecialHours_SelectionInput(this: any) : ReturnTypeFromPartial_SpecialHours_Selection {
                return {
                    date: new SelectionWrapper(
            "date",
            "Date",
            0,
            {},
            this,
            undefined,
            ),
openedAt: new SelectionWrapper(
            "openedAt",
            "String",
            0,
            {},
            this,
            undefined,
            ),
closedAt: new SelectionWrapper(
            "closedAt",
            "String",
            0,
            {},
            this,
            undefined,
            ),
isClosed: new SelectionWrapper(
            "isClosed",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makePartial_SpecialHours_SelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makePartial_SpecialHours_SelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makePartial_SpecialHours_SelectionInput.bind(this)() as any,
                    "Partial_SpecialHours_",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const Partial_SpecialHours_Selection = makeSLFN(
                makePartial_SpecialHours_SelectionInput,
                "Partial_SpecialHours_Selection",
                "Partial_SpecialHours_",
                0
            );
        
        

        type ReturnTypeFrom_Duplicate1_Partial_SpecialHours_SelectionRetTypes<AS_PROMISE = 0> = {
        date: SelectionWrapperImpl<"date", "Date", 0, {}, undefined>
openedAt: SelectionWrapperImpl<"openedAt", "String", 0, {}, undefined>
closedAt: SelectionWrapperImpl<"closedAt", "String", 0, {}, undefined>
isClosed: SelectionWrapperImpl<"isClosed", "Boolean", 0, {}, undefined>
        }
        type ReturnTypeFrom_Duplicate1_Partial_SpecialHours_Selection = {
            date:  ReturnTypeFrom_Duplicate1_Partial_SpecialHours_SelectionRetTypes["date"]
openedAt:  ReturnTypeFrom_Duplicate1_Partial_SpecialHours_SelectionRetTypes["openedAt"]
closedAt:  ReturnTypeFrom_Duplicate1_Partial_SpecialHours_SelectionRetTypes["closedAt"]
isClosed:  ReturnTypeFrom_Duplicate1_Partial_SpecialHours_SelectionRetTypes["isClosed"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof make_Duplicate1_Partial_SpecialHours_SelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<_Duplicate1_Partial_SpecialHours_>, "_Duplicate1_Partial_SpecialHours_">;
        };
            
            export function make_Duplicate1_Partial_SpecialHours_SelectionInput(this: any) : ReturnTypeFrom_Duplicate1_Partial_SpecialHours_Selection {
                return {
                    date: new SelectionWrapper(
            "date",
            "Date",
            0,
            {},
            this,
            undefined,
            ),
openedAt: new SelectionWrapper(
            "openedAt",
            "String",
            0,
            {},
            this,
            undefined,
            ),
closedAt: new SelectionWrapper(
            "closedAt",
            "String",
            0,
            {},
            this,
            undefined,
            ),
isClosed: new SelectionWrapper(
            "isClosed",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        make_Duplicate1_Partial_SpecialHours_SelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof make_Duplicate1_Partial_SpecialHours_SelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    make_Duplicate1_Partial_SpecialHours_SelectionInput.bind(this)() as any,
                    "_Duplicate1_Partial_SpecialHours_",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const _Duplicate1_Partial_SpecialHours_Selection = makeSLFN(
                make_Duplicate1_Partial_SpecialHours_SelectionInput,
                "_Duplicate1_Partial_SpecialHours_Selection",
                "_Duplicate1_Partial_SpecialHours_",
                0
            );
        
        

        type ReturnTypeFromDeliveryAreaSelectionRetTypes<AS_PROMISE = 0> = {
        name: SelectionWrapperImpl<"name", "String!", 0, {}, undefined>
description: SelectionWrapperImpl<"description", "String", 0, {}, undefined>
fee: SelectionWrapperImpl<"fee", "stringOrNumberDecimal", 0, {}, undefined>
mov: SelectionWrapperImpl<"mov", "stringOrNumberDecimal", 0, {}, undefined>
location: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makePolygonNotNullSelectionInput>,
                                                "PolygonNotNullSelection",
                                                "Polygon",
                                                0
                                                
                                            >
                                        >
        }
        type ReturnTypeFromDeliveryAreaSelection = {
            name:  ReturnTypeFromDeliveryAreaSelectionRetTypes["name"]
description:  ReturnTypeFromDeliveryAreaSelectionRetTypes["description"]
fee:  ReturnTypeFromDeliveryAreaSelectionRetTypes["fee"]
mov:  ReturnTypeFromDeliveryAreaSelectionRetTypes["mov"]
location:  ReturnTypeFromDeliveryAreaSelectionRetTypes["location"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeDeliveryAreaSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<DeliveryArea>, "DeliveryArea">;
        };
            
            export function makeDeliveryAreaSelectionInput(this: any) : ReturnTypeFromDeliveryAreaSelection {
                return {
                    name: new SelectionWrapper(
            "name",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
description: new SelectionWrapper(
            "description",
            "String",
            0,
            {},
            this,
            undefined,
            ),
fee: new SelectionWrapper(
            "fee",
            "stringOrNumberDecimal",
            0,
            {},
            this,
            undefined,
            ),
mov: new SelectionWrapper(
            "mov",
            "stringOrNumberDecimal",
            0,
            {},
            this,
            undefined,
            ),
location: PolygonNotNullSelection.bind({ collector: this, fieldName: "location" }),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeDeliveryAreaSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeDeliveryAreaSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeDeliveryAreaSelectionInput.bind(this)() as any,
                    "DeliveryArea",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const DeliveryAreaSelection = makeSLFN(
                makeDeliveryAreaSelectionInput,
                "DeliveryAreaSelection",
                "DeliveryArea",
                0
            );
        
        

        type ReturnTypeFromPolygonSelectionRetTypes<AS_PROMISE = 0> = {
        type: SelectionWrapperImpl<"type", "Constant_Polygon!", 0, {}, undefined>
coordinates: SelectionWrapperImpl<"coordinates", "Float", 3, {}, undefined>
        }
        type ReturnTypeFromPolygonSelection = {
            type:  ReturnTypeFromPolygonSelectionRetTypes["type"]
coordinates:  ReturnTypeFromPolygonSelectionRetTypes["coordinates"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makePolygonSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Polygon>, "Polygon">;
        };
            
            export function makePolygonSelectionInput(this: any) : ReturnTypeFromPolygonSelection {
                return {
                    type: new SelectionWrapper(
            "type",
            "Constant_Polygon!",
            0,
            {},
            this,
            undefined,
            ),
coordinates: new SelectionWrapper(
            "coordinates",
            "Float",
            3,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makePolygonSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makePolygonSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makePolygonSelectionInput.bind(this)() as any,
                    "Polygon",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const PolygonSelection = makeSLFN(
                makePolygonSelectionInput,
                "PolygonSelection",
                "Polygon",
                0
            );
        
        

        type ReturnTypeFromLocalizationSelectionRetTypes<AS_PROMISE = 0> = {
        de: SelectionWrapperImpl<"de", "String", 0, {}, undefined>
en: SelectionWrapperImpl<"en", "String", 0, {}, undefined>
fr: SelectionWrapperImpl<"fr", "String", 0, {}, undefined>
nl: SelectionWrapperImpl<"nl", "String", 0, {}, undefined>
it: SelectionWrapperImpl<"it", "String", 0, {}, undefined>
pl: SelectionWrapperImpl<"pl", "String", 0, {}, undefined>
es: SelectionWrapperImpl<"es", "String", 0, {}, undefined>
zh: SelectionWrapperImpl<"zh", "String", 0, {}, undefined>
ru: SelectionWrapperImpl<"ru", "String", 0, {}, undefined>
tr: SelectionWrapperImpl<"tr", "String", 0, {}, undefined>
da: SelectionWrapperImpl<"da", "String", 0, {}, undefined>
ja: SelectionWrapperImpl<"ja", "String", 0, {}, undefined>
is: SelectionWrapperImpl<"is", "String", 0, {}, undefined>
pt: SelectionWrapperImpl<"pt", "String", 0, {}, undefined>
cz: SelectionWrapperImpl<"cz", "String", 0, {}, undefined>
cs: SelectionWrapperImpl<"cs", "String", 0, {}, undefined>
        }
        type ReturnTypeFromLocalizationSelection = {
            de:  ReturnTypeFromLocalizationSelectionRetTypes["de"]
en:  ReturnTypeFromLocalizationSelectionRetTypes["en"]
fr:  ReturnTypeFromLocalizationSelectionRetTypes["fr"]
nl:  ReturnTypeFromLocalizationSelectionRetTypes["nl"]
it:  ReturnTypeFromLocalizationSelectionRetTypes["it"]
pl:  ReturnTypeFromLocalizationSelectionRetTypes["pl"]
es:  ReturnTypeFromLocalizationSelectionRetTypes["es"]
zh:  ReturnTypeFromLocalizationSelectionRetTypes["zh"]
ru:  ReturnTypeFromLocalizationSelectionRetTypes["ru"]
tr:  ReturnTypeFromLocalizationSelectionRetTypes["tr"]
da:  ReturnTypeFromLocalizationSelectionRetTypes["da"]
ja:  ReturnTypeFromLocalizationSelectionRetTypes["ja"]
is:  ReturnTypeFromLocalizationSelectionRetTypes["is"]
pt:  ReturnTypeFromLocalizationSelectionRetTypes["pt"]
cz:  ReturnTypeFromLocalizationSelectionRetTypes["cz"]
cs:  ReturnTypeFromLocalizationSelectionRetTypes["cs"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeLocalizationSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Localization>, "Localization">;
        };
            
            export function makeLocalizationSelectionInput(this: any) : ReturnTypeFromLocalizationSelection {
                return {
                    de: new SelectionWrapper(
            "de",
            "String",
            0,
            {},
            this,
            undefined,
            ),
en: new SelectionWrapper(
            "en",
            "String",
            0,
            {},
            this,
            undefined,
            ),
fr: new SelectionWrapper(
            "fr",
            "String",
            0,
            {},
            this,
            undefined,
            ),
nl: new SelectionWrapper(
            "nl",
            "String",
            0,
            {},
            this,
            undefined,
            ),
it: new SelectionWrapper(
            "it",
            "String",
            0,
            {},
            this,
            undefined,
            ),
pl: new SelectionWrapper(
            "pl",
            "String",
            0,
            {},
            this,
            undefined,
            ),
es: new SelectionWrapper(
            "es",
            "String",
            0,
            {},
            this,
            undefined,
            ),
zh: new SelectionWrapper(
            "zh",
            "String",
            0,
            {},
            this,
            undefined,
            ),
ru: new SelectionWrapper(
            "ru",
            "String",
            0,
            {},
            this,
            undefined,
            ),
tr: new SelectionWrapper(
            "tr",
            "String",
            0,
            {},
            this,
            undefined,
            ),
da: new SelectionWrapper(
            "da",
            "String",
            0,
            {},
            this,
            undefined,
            ),
ja: new SelectionWrapper(
            "ja",
            "String",
            0,
            {},
            this,
            undefined,
            ),
is: new SelectionWrapper(
            "is",
            "String",
            0,
            {},
            this,
            undefined,
            ),
pt: new SelectionWrapper(
            "pt",
            "String",
            0,
            {},
            this,
            undefined,
            ),
cz: new SelectionWrapper(
            "cz",
            "String",
            0,
            {},
            this,
            undefined,
            ),
cs: new SelectionWrapper(
            "cs",
            "String",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeLocalizationSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeLocalizationSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeLocalizationSelectionInput.bind(this)() as any,
                    "Localization",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const LocalizationSelection = makeSLFN(
                makeLocalizationSelectionInput,
                "LocalizationSelection",
                "Localization",
                0
            );
        
        

        type ReturnTypeFrom_coordinates_numberArray_type_string_SelectionRetTypes<AS_PROMISE = 0> = {
        coordinates: SelectionWrapperImpl<"coordinates", "Float", 1, {}, undefined>
type: SelectionWrapperImpl<"type", "String", 0, {}, undefined>
        }
        type ReturnTypeFrom_coordinates_numberArray_type_string_Selection = {
            coordinates:  ReturnTypeFrom_coordinates_numberArray_type_string_SelectionRetTypes["coordinates"]
type:  ReturnTypeFrom_coordinates_numberArray_type_string_SelectionRetTypes["type"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof make_coordinates_numberArray_type_string_SelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<_coordinates_numberArray_type_string_>, "_coordinates_numberArray_type_string_">;
        };
            
            export function make_coordinates_numberArray_type_string_SelectionInput(this: any) : ReturnTypeFrom_coordinates_numberArray_type_string_Selection {
                return {
                    coordinates: new SelectionWrapper(
            "coordinates",
            "Float",
            1,
            {},
            this,
            undefined,
            ),
type: new SelectionWrapper(
            "type",
            "String",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        make_coordinates_numberArray_type_string_SelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof make_coordinates_numberArray_type_string_SelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    make_coordinates_numberArray_type_string_SelectionInput.bind(this)() as any,
                    "_coordinates_numberArray_type_string_",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const _coordinates_numberArray_type_string_Selection = makeSLFN(
                make_coordinates_numberArray_type_string_SelectionInput,
                "_coordinates_numberArray_type_string_Selection",
                "_coordinates_numberArray_type_string_",
                0
            );
        
        

        type ReturnTypeFromExternalDeliveryServiceSelectionRetTypes<AS_PROMISE = 0> = {
        image: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeAssetsSelectionInput>,
                                                "AssetsSelection",
                                                "Assets",
                                                0
                                                
                                            >
                                        >
link: SelectionWrapperImpl<"link", "String", 0, {}, undefined>
name: SelectionWrapperImpl<"name", "String", 0, {}, undefined>
        }
        type ReturnTypeFromExternalDeliveryServiceSelection = {
            image:  ReturnTypeFromExternalDeliveryServiceSelectionRetTypes["image"]
link:  ReturnTypeFromExternalDeliveryServiceSelectionRetTypes["link"]
name:  ReturnTypeFromExternalDeliveryServiceSelectionRetTypes["name"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeExternalDeliveryServiceSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<ExternalDeliveryService>, "ExternalDeliveryService">;
        };
            
            export function makeExternalDeliveryServiceSelectionInput(this: any) : ReturnTypeFromExternalDeliveryServiceSelection {
                return {
                    image: AssetsSelection.bind({ collector: this, fieldName: "image" }),
link: new SelectionWrapper(
            "link",
            "String",
            0,
            {},
            this,
            undefined,
            ),
name: new SelectionWrapper(
            "name",
            "String",
            0,
            {},
            this,
            undefined,
            ),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeExternalDeliveryServiceSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeExternalDeliveryServiceSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeExternalDeliveryServiceSelectionInput.bind(this)() as any,
                    "ExternalDeliveryService",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const ExternalDeliveryServiceSelection = makeSLFN(
                makeExternalDeliveryServiceSelectionInput,
                "ExternalDeliveryServiceSelection",
                "ExternalDeliveryService",
                0
            );
        
        

        type ReturnTypeFromMapsPoiVenueSelectionRetTypes<AS_PROMISE = 0> = {
        _id: SelectionWrapperImpl<"_id", "String!", 0, {}, undefined>
readableId: SelectionWrapperImpl<"readableId", "String", 0, {}, undefined>
name: SelectionWrapperImpl<"name", "String!", 0, {}, undefined>
isPublished: SelectionWrapperImpl<"isPublished", "Boolean", 0, {}, undefined>
isServiceActivated: SelectionWrapperImpl<"isServiceActivated", "Boolean", 0, {}, undefined>
currency: SelectionWrapperImpl<"currency", "Currency!", 0, {}, undefined>
preorderTable: SelectionWrapperImpl<"preorderTable", "String", 0, {}, undefined>
openingHours: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeHoursNotNullArraySelectionInput>,
                                                "HoursNotNullArraySelection",
                                                "Hours",
                                                1
                                                
                                            >
                                        >
deliveryHours: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeHoursNotNullArraySelectionInput>,
                                                "HoursNotNullArraySelection",
                                                "Hours",
                                                1
                                                
                                            >
                                        >
specialOpeningHours: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makePartial_SpecialHours_ArraySelectionInput>,
                                                "Partial_SpecialHours_ArraySelection",
                                                "Partial_SpecialHours_",
                                                1
                                                
                                            >
                                        >
specialDeliveryHours: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof make_Duplicate1_Partial_SpecialHours_ArraySelectionInput>,
                                                "_Duplicate1_Partial_SpecialHours_ArraySelection",
                                                "_Duplicate1_Partial_SpecialHours_",
                                                1
                                                
                                            >
                                        >
cateringHoursTakeAway: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeHoursNotNullArraySelectionInput>,
                                                "HoursNotNullArraySelection",
                                                "Hours",
                                                1
                                                
                                            >
                                        >
panicEndAt: SelectionWrapperImpl<"panicEndAt", "Date", 0, {}, undefined>
preorderTakeAway: SelectionWrapperImpl<"preorderTakeAway", "Boolean!", 0, {}, undefined>
preorderIn: SelectionWrapperImpl<"preorderIn", "Boolean!", 0, {}, undefined>
deliveryEnabled: SelectionWrapperImpl<"deliveryEnabled", "Boolean", 0, {}, undefined>
deliveryByAreas: SelectionWrapperImpl<"deliveryByAreas", "Boolean", 0, {}, undefined>
deliveryByRadius: SelectionWrapperImpl<"deliveryByRadius", "Boolean", 0, {}, undefined>
isPostalDelivery: SelectionWrapperImpl<"isPostalDelivery", "Boolean", 0, {}, undefined>
deliveryAreas: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeDeliveryAreaNotNullArraySelectionInput>,
                                                "DeliveryAreaNotNullArraySelection",
                                                "DeliveryArea",
                                                1
                                                
                                            >
                                        >
deliveryPostalCodes: SelectionWrapperImpl<"deliveryPostalCodes", "String", 1, {}, undefined>
deliveryRadius: SelectionWrapperImpl<"deliveryRadius", "Float", 0, {}, undefined>
distance: SelectionWrapperImpl<"distance", "Float", 0, {}, undefined>
cateringTakeAway: SelectionWrapperImpl<"cateringTakeAway", "Boolean", 0, {}, undefined>
cateringDelivery: SelectionWrapperImpl<"cateringDelivery", "Boolean", 0, {}, undefined>
offsets: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makePartial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_SelectionInput>,
                                                "Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_Selection",
                                                "Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_",
                                                0
                                                
                                            >
                                        >
firstPreorderOffset: SelectionWrapperImpl<"firstPreorderOffset", "Float", 0, {}, undefined>
preorderOffset: SelectionWrapperImpl<"preorderOffset", "Float", 0, {}, undefined>
lastPreorderOffset: SelectionWrapperImpl<"lastPreorderOffset", "Float", 0, {}, undefined>
city: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeLocalizationNotNullSelectionInput>,
                                                "LocalizationNotNullSelection",
                                                "Localization",
                                                0
                                                
                                            >
                                        >
street: SelectionWrapperImpl<"street", "String", 0, {}, undefined>
number: SelectionWrapperImpl<"number", "String", 0, {}, undefined>
phoneNumber: SelectionWrapperImpl<"phoneNumber", "String", 0, {}, undefined>
address: SelectionWrapperImpl<"address", "String", 0, {}, undefined>
country: SelectionWrapperImpl<"country", "String!", 0, {}, undefined>
website: SelectionWrapperImpl<"website", "String", 0, {}, undefined>
postalCode: SelectionWrapperImpl<"postalCode", "String", 0, {}, undefined>
location: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof make_coordinates_numberArray_type_string_NotNullSelectionInput>,
                                                "_coordinates_numberArray_type_string_NotNullSelection",
                                                "_coordinates_numberArray_type_string_",
                                                0
                                                
                                            >
                                        >
externalDeliveryService: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeExternalDeliveryServiceNotNullArraySelectionInput>,
                                                "ExternalDeliveryServiceNotNullArraySelection",
                                                "ExternalDeliveryService",
                                                1
                                                
                                            >
                                        >
        }
        type ReturnTypeFromMapsPoiVenueSelection = {
            _id:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["_id"]
readableId:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["readableId"]
name:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["name"]
isPublished:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["isPublished"]
isServiceActivated:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["isServiceActivated"]
currency:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["currency"]
preorderTable:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["preorderTable"]
openingHours:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["openingHours"]
deliveryHours:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["deliveryHours"]
specialOpeningHours:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["specialOpeningHours"]
specialDeliveryHours:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["specialDeliveryHours"]
cateringHoursTakeAway:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["cateringHoursTakeAway"]
panicEndAt:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["panicEndAt"]
preorderTakeAway:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["preorderTakeAway"]
preorderIn:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["preorderIn"]
deliveryEnabled:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["deliveryEnabled"]
deliveryByAreas:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["deliveryByAreas"]
deliveryByRadius:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["deliveryByRadius"]
isPostalDelivery:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["isPostalDelivery"]
deliveryAreas:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["deliveryAreas"]
deliveryPostalCodes:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["deliveryPostalCodes"]
deliveryRadius:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["deliveryRadius"]
distance:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["distance"]
cateringTakeAway:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["cateringTakeAway"]
cateringDelivery:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["cateringDelivery"]
offsets:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["offsets"]
firstPreorderOffset:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["firstPreorderOffset"]
preorderOffset:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["preorderOffset"]
lastPreorderOffset:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["lastPreorderOffset"]
city:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["city"]
street:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["street"]
number:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["number"]
phoneNumber:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["phoneNumber"]
address:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["address"]
country:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["country"]
website:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["website"]
postalCode:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["postalCode"]
location:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["location"]
externalDeliveryService:  ReturnTypeFromMapsPoiVenueSelectionRetTypes["externalDeliveryService"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $scalars: () => SLWsFromSelection<ReturnType<typeof makeMapsPoiVenueSelectionInput>>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<MapsPoiVenue>, "MapsPoiVenue">;
        };
            
            export function makeMapsPoiVenueSelectionInput(this: any) : ReturnTypeFromMapsPoiVenueSelection {
                return {
                    _id: new SelectionWrapper(
            "_id",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
readableId: new SelectionWrapper(
            "readableId",
            "String",
            0,
            {},
            this,
            undefined,
            ),
name: new SelectionWrapper(
            "name",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
isPublished: new SelectionWrapper(
            "isPublished",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
isServiceActivated: new SelectionWrapper(
            "isServiceActivated",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
currency: new SelectionWrapper(
            "currency",
            "Currency!",
            0,
            {},
            this,
            undefined,
            ),
preorderTable: new SelectionWrapper(
            "preorderTable",
            "String",
            0,
            {},
            this,
            undefined,
            ),
openingHours: HoursNotNullArraySelection.bind({ collector: this, fieldName: "openingHours" }),
deliveryHours: HoursNotNullArraySelection.bind({ collector: this, fieldName: "deliveryHours" }),
specialOpeningHours: Partial_SpecialHours_ArraySelection.bind({ collector: this, fieldName: "specialOpeningHours" }),
specialDeliveryHours: _Duplicate1_Partial_SpecialHours_ArraySelection.bind({ collector: this, fieldName: "specialDeliveryHours" }),
cateringHoursTakeAway: HoursNotNullArraySelection.bind({ collector: this, fieldName: "cateringHoursTakeAway" }),
panicEndAt: new SelectionWrapper(
            "panicEndAt",
            "Date",
            0,
            {},
            this,
            undefined,
            ),
preorderTakeAway: new SelectionWrapper(
            "preorderTakeAway",
            "Boolean!",
            0,
            {},
            this,
            undefined,
            ),
preorderIn: new SelectionWrapper(
            "preorderIn",
            "Boolean!",
            0,
            {},
            this,
            undefined,
            ),
deliveryEnabled: new SelectionWrapper(
            "deliveryEnabled",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
deliveryByAreas: new SelectionWrapper(
            "deliveryByAreas",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
deliveryByRadius: new SelectionWrapper(
            "deliveryByRadius",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
isPostalDelivery: new SelectionWrapper(
            "isPostalDelivery",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
deliveryAreas: DeliveryAreaNotNullArraySelection.bind({ collector: this, fieldName: "deliveryAreas" }),
deliveryPostalCodes: new SelectionWrapper(
            "deliveryPostalCodes",
            "String",
            1,
            {},
            this,
            undefined,
            ),
deliveryRadius: new SelectionWrapper(
            "deliveryRadius",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
distance: new SelectionWrapper(
            "distance",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
cateringTakeAway: new SelectionWrapper(
            "cateringTakeAway",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
cateringDelivery: new SelectionWrapper(
            "cateringDelivery",
            "Boolean",
            0,
            {},
            this,
            undefined,
            ),
offsets: Partial_standard_OrderOffset_preorder_inside_OrderOffset_takeAway_OrderOffset_delivery_OrderOffset_catering_delivery_OrderOffset_takeAway_OrderOffset_terminal_inside_OrderOffset_takeAway_OrderOffset_Selection.bind({ collector: this, fieldName: "offsets" }),
firstPreorderOffset: new SelectionWrapper(
            "firstPreorderOffset",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
preorderOffset: new SelectionWrapper(
            "preorderOffset",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
lastPreorderOffset: new SelectionWrapper(
            "lastPreorderOffset",
            "Float",
            0,
            {},
            this,
            undefined,
            ),
city: LocalizationNotNullSelection.bind({ collector: this, fieldName: "city" }),
street: new SelectionWrapper(
            "street",
            "String",
            0,
            {},
            this,
            undefined,
            ),
number: new SelectionWrapper(
            "number",
            "String",
            0,
            {},
            this,
            undefined,
            ),
phoneNumber: new SelectionWrapper(
            "phoneNumber",
            "String",
            0,
            {},
            this,
            undefined,
            ),
address: new SelectionWrapper(
            "address",
            "String",
            0,
            {},
            this,
            undefined,
            ),
country: new SelectionWrapper(
            "country",
            "String!",
            0,
            {},
            this,
            undefined,
            ),
website: new SelectionWrapper(
            "website",
            "String",
            0,
            {},
            this,
            undefined,
            ),
postalCode: new SelectionWrapper(
            "postalCode",
            "String",
            0,
            {},
            this,
            undefined,
            ),
location: _coordinates_numberArray_type_string_NotNullSelection.bind({ collector: this, fieldName: "location" }),
externalDeliveryService: ExternalDeliveryServiceNotNullArraySelection.bind({ collector: this, fieldName: "externalDeliveryService" }),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $scalars: () =>
                selectScalars(
                        makeMapsPoiVenueSelectionInput.bind(this)(),
                    ) as SLWsFromSelection<
                        ReturnType<typeof makeMapsPoiVenueSelectionInput>
                    >,
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeMapsPoiVenueSelectionInput.bind(this)() as any,
                    "MapsPoiVenue",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const MapsPoiVenueSelection = makeSLFN(
                makeMapsPoiVenueSelectionInput,
                "MapsPoiVenueSelection",
                "MapsPoiVenue",
                0
            );
        
        

        type ReturnTypeFromQuerySelectionRetTypes<AS_PROMISE = 0> = {
        mapsPoiVenues: ReturnType<
                                            SLFN<
                                                {},
                                                ReturnType<typeof makeMapsPoiVenueNotNullArraySelectionInput>,
                                                "MapsPoiVenueNotNullArraySelection",
                                                "MapsPoiVenue",
                                                1
                                                ,
                                                { 
                                                    
                            $lazy: (
                                args: QueryMapsPoiVenuesArgs
                            ) => Promise<"T"> & {
                                                        auth: (auth: FnOrPromisOrPrimitive) => Promise<"T">;
                                                    };
                                                    auth: (auth: FnOrPromisOrPrimitive) => Promise<"T"> & {
                            $lazy: (
                                args: QueryMapsPoiVenuesArgs
                            ) => Promise<"T">}
                                                },
                                                "$lazy" | "auth",
                                                AS_PROMISE
                                                
                                                
                                            >
                                        >
        }
        type ReturnTypeFromQuerySelection = {
            mapsPoiVenues: (
                                        args: QueryMapsPoiVenuesArgs
                                    ) => ReturnTypeFromQuerySelectionRetTypes["mapsPoiVenues"]
        } & {
            $fragment: <F extends (this: any, ...args: any[]) => any>(
                f: F,
            ) => (
                ...args: ArgumentsTypeFromFragment<F>
            ) => ReturnTypeFromFragment<F>;
            
            $all: selectAllFunc<AllNonFuncFieldsFromType<Query>, "Query">;
        };
            
            export function makeQuerySelectionInput(this: any) : ReturnTypeFromQuerySelection {
                return {
                    mapsPoiVenues: (args: QueryMapsPoiVenuesArgs) => MapsPoiVenueNotNullArraySelection.bind({ collector: this, fieldName: "mapsPoiVenues", args, argsMeta: QueryMapsPoiVenuesArgsMeta }),

                    
            $fragment: <F extends (this: any, ...args: any[]) => any>(f: F) =>
                f.bind({
                    collector: this,
                    fieldName: "",
                    isFragment: f.name,
                }) as ((...args: ArgumentsTypeFromFragment<F>) => ReturnTypeFromFragment<F>),
            
            $all: (opts?: any, collector = undefined) =>
                selectAll(
                    makeQuerySelectionInput.bind(this)() as any,
                    "Query",
                    opts as any,
                    collector
                ) as any
            
                } as const;
            };
            export const QuerySelection = makeSLFN(
                makeQuerySelectionInput,
                "QuerySelection",
                "Query",
                0
            );
        
        

            export const _directive_include = (
                args: Directive_includeArgs
            ) => <F>(
                f: F
            ) => {
                (f as any)[SLW_DIRECTIVE] = "include";
                (f as any)[SLW_DIRECTIVE_ARGS] = args;
                (f as any)[SLW_DIRECTIVE_ARGS_META] = Directive_includeArgsMeta;
                return f;
            }
        

            export const _directive_skip = (
                args: Directive_skipArgs
            ) => <F>(
                f: F
            ) => {
                (f as any)[SLW_DIRECTIVE] = "skip";
                (f as any)[SLW_DIRECTIVE_ARGS] = args;
                (f as any)[SLW_DIRECTIVE_ARGS_META] = Directive_skipArgsMeta;
                return f;
            }
        

            export const $directives = {
                        "include": _directive_include,
"skip": _directive_skip
                    } as const;
            export function _makeRootOperationInput(this: any) {
                return {
                    Query: QuerySelection.bind({
                                collector: this,
                                isRootType: "Query",
                    }),

                    
                        $directives,
                } as const;
            };

            function __client__ <
                T extends object,
                F extends ReturnType<typeof _makeRootOperationInput>>(
                this: any, 
                s: (selection: F) => T
            ) {
                const root = new OperationSelectionCollector(undefined, undefined, new RootOperation());
                const rootRef = { ref: root };
                const selection: F = _makeRootOperationInput.bind(rootRef)() as any;
                const r = s(selection);
                const _result = new SelectionWrapper(undefined, undefined, undefined, r, root, undefined) as unknown as T;
                Object.keys(r).forEach((key) => (_result as T)[key as keyof T]);
                
                type excludeLazy<T> = { [key in Exclude<keyof T, "$lazy">]: T[key] };

                // remove the $lazy property from the result
                const result = _result as {
                    [k in keyof T]: T[k] extends { $lazy: any }
                        ? // if T[k] is an array and has a $lazy property, return the type of the array elements
                        T[k] extends (infer U)[] & { $lazy: any }
                            ? U[]
                            : // if T[k] is an object and has a $lazy property, return the type of the object
                            excludeLazy<T[k]>
                        : // if T[k] is a function and has a $lazy property, return the type of the function
                        T[k] extends (args: infer A) => Promise<infer R>
                        ? (args: A) => Promise<R>
                        : T[k];
                };

                type _TR = typeof result;
                type __HasPromisesAndOrNonPromisesK = {
                    [k in keyof _TR]: _TR[k] extends (args: any) => Promise<any>
                        ? "promise"
                        : "non-promise";
                };
                type __HasPromisesAndOrNonPromises =
                    __HasPromisesAndOrNonPromisesK[keyof __HasPromisesAndOrNonPromisesK];
                type finalReturnTypeBasedOnIfHasLazyPromises =
                    __HasPromisesAndOrNonPromises extends "non-promise"
                        ? Promise<_TR>
                        : __HasPromisesAndOrNonPromises extends "promise"
                        ? _TR
                        : Promise<_TR>;

                const resultProxy = new Proxy(
                    {},
                    {
                        get(_t, _prop) {
                            const rAtProp = result[_prop as keyof T];
                            if (typeof rAtProp === "function") {
                                return rAtProp;
                            }
                            const promise = new Promise((resolve, reject) => {
                                root.execute()
                                    .catch(reject)
                                    .then(() => {
                                        resolve(rAtProp);
                                    });
                            });
                            if (String(_prop) === "then") {
                                return promise.then.bind(promise);
                            }
                            return promise;
                        },
                    },
                ) as any;

                return new Proxy(
                    {},
                    {
                        get(_t, _prop) {
                            if (String(_prop) === "auth") {
                                return (auth: FnOrPromisOrPrimitive) => {
                                    root.op!.setAuth(auth);
                                    return resultProxy;
                                };
                            }
                            return resultProxy[_prop];
                        },
                    },
                ) as finalReturnTypeBasedOnIfHasLazyPromises & {
                    auth: (
                        auth: FnOrPromisOrPrimitive,
                    ) => finalReturnTypeBasedOnIfHasLazyPromises;
                };
            };

            const __init__ = (options: {
                auth?: FnOrPromisOrPrimitive;
                headers?: { [key: string]: string };
                fetcher?: (
                    input: string | URL | globalThis.Request,
                    init?: RequestInit,
                ) => Promise<Response>;
                sseFetchTransform?: (
                    input: string | URL | globalThis.Request,
                    init?: RequestInit,
                ) => Promise<[string | URL | globalThis.Request, RequestInit | undefined]>;
                scalars?: {
                    [key in keyof ScalarTypeMapDefault]?: (
                        v: string,
                    ) => ScalarTypeMapDefault[key];
                } & {
                    [key in keyof ScalarTypeMapWithCustom]?: (
                        v: string,
                    ) => ScalarTypeMapWithCustom[key];
                };
            }) => {
                
                if (typeof options.auth === "string") {
                    RootOperation[OPTIONS].headers = {
                        "Authorization": options.auth,
                    };
                } else if (typeof options.auth === "function" ) {
                    RootOperation[OPTIONS]._auth_fn = options.auth;
                }
                else if (options.auth) {
                    RootOperation[OPTIONS].headers = options.auth;
                }
                

                if (options.headers) {
                    RootOperation[OPTIONS].headers = {
                        ...RootOperation[OPTIONS].headers,
                        ...options.headers,
                    };
                }
                if (options.fetcher) {
                    RootOperation[OPTIONS].fetcher = options.fetcher;
                }
                if (options.sseFetchTransform) {
                    RootOperation[OPTIONS].sseFetchTransform = options.sseFetchTransform;
                }
                if (options.scalars) {
                    RootOperation[OPTIONS].scalars = {
                        ...RootOperation[OPTIONS].scalars,
                        ...options.scalars,
                    };
                }
            };
            Object.defineProperty(__client__, "init", {
                enumerable: false,
                value: __init__,
            });

            const _makeOperationShortcut = <O extends "Query">(
                operation: O,
                field: Exclude<
                    keyof ReturnTypeFromQuerySelection,
                    "$fragment" | "$scalars" | "$all"
                >,
            ) => {
                const root = new OperationSelectionCollector(
                    undefined,
                    undefined,
                    new RootOperation(),
                );
                const rootRef = { ref: root };

                let fieldFn: 
                    ReturnTypeFromQuerySelection[Exclude<
                        keyof ReturnTypeFromQuerySelection,
                        "$fragment" | "$scalars" | "$all"
                    >];
                
                    
                    fieldFn =
                        makeQuerySelectionInput.bind(rootRef)()[
                            field as Exclude<
                                keyof ReturnTypeFromQuerySelection,
                                "$fragment" | "$scalars" | "$all"
                            >
                        ];
                
                

                if (typeof fieldFn === "function") {
                    const makeSubSelectionFn =
                        (
                            opFnArgs?: Exclude<
                                Parameters<Extract<typeof fieldFn, (args: any) => any>>[0],
                                (args: any) => any
                            >,
                        ) =>
                        (opFnSelectionCb: (selection: unknown) => unknown) => {
                            const fieldSLFN =
                                opFnArgs === undefined
                                    ? fieldFn
                                    : (
                                        fieldFn as (
                                            args: typeof opFnArgs,
                                        ) => (s: typeof opFnSelectionCb) => unknown
                                    )(opFnArgs);

                            const fieldSlw = (fieldSLFN as Extract<typeof fieldSLFN, (args: any) => any>)(
                                opFnSelectionCb as any,
                            ) as unknown as SelectionWrapperImpl<
                                typeof field,
                                string,
                                number,
                                any,
                                typeof opFnArgs
                            >;
                            const opSlw = new SelectionWrapper(
                                undefined,
                                undefined,
                                undefined,
                                { [field]: fieldSlw },
                                new OperationSelectionCollector(
                                    operation + "Selection",
                                    root,
                                ),
                                root,
                            );
                            fieldSlw[SLW_PARENT_SLW] = opSlw;
                            opSlw[SLW_IS_ROOT_TYPE] = operation;
                            opSlw[SLW_PARENT_COLLECTOR] = opSlw[SLW_COLLECTOR];
                            // access the keys of the proxy object, to register operations
                            Object.keys({ [field]: 0 }).forEach(key => (opSlw as any)[key as any]);
                            const rootSlw = new SelectionWrapper(
                                undefined,
                                undefined,
                                undefined,
                                opSlw,
                                root,
                            );
                            opSlw[ROOT_OP_COLLECTOR] = rootRef;
                            // access the keys of the proxy object, to register operations
                            Object.keys({ [field]: 0 }).forEach(key => (rootSlw as any)[key as any]);
                                
                            const resultProxy = new Proxy(
                                {},
                                {
                                    get(_t, _prop) {
                                        if (String(_prop) === "$lazy") {
                                            return (fieldSlw as any)["$lazy"].bind({
                                                parentSlw: opSlw,
                                                key: field,
                                            });
                                        } else {
                                            const result = new Promise((resolve, reject) => {
                                                root.execute()
                                                    .catch(reject)
                                                    .then(() => {
                                                        resolve((rootSlw as any)[field]);
                                                    });
                                            });
                                            if (String(_prop) === "then") {
                                                return result.then.bind(result);
                                            }
                                            return result;
                                        }
                                    },
                                },
                            ) as any;

                            return new Proxy(
                                {},
                                {
                                    get(_t, _prop) {
                                        if (String(_prop) === "auth") {
                                            return (auth: FnOrPromisOrPrimitive) => {
                                                root.op!.setAuth(auth);
                                                return resultProxy;
                                            };
                                        }
                                        return resultProxy[_prop];
                                    },
                                },
                            );
                        };

                    // if the fieldFn is the SLFN subselection function without an (args) => .. wrapper
                    if (fieldFn.name.startsWith("bound ")) {
                        return makeSubSelectionFn();
                    }
                    return (
                        opFnArgs: Exclude<
                            Parameters<Extract<typeof fieldFn, (args: any) => any>>[0],
                            (args: any) => any
                        >,
                    ) => {
                        return makeSubSelectionFn(opFnArgs);
                    };
                } else {
                    const fieldSlw = fieldFn as SelectionWrapperImpl<any, any, any>;
                    const opSlw = new SelectionWrapper(
                        undefined,
                        undefined,
                        undefined,
                        { [field]: fieldSlw },
                        new OperationSelectionCollector(operation + "Selection", root),
                        root,
                    );
                    fieldSlw[ROOT_OP_COLLECTOR] = rootRef;
                    opSlw[SLW_IS_ROOT_TYPE] = operation;
                    opSlw[SLW_PARENT_COLLECTOR] = opSlw[SLW_COLLECTOR];
                    opSlw[SLW_PARENT_SLW] = opSlw;
                    // access the keys of the proxy object, to register operations
                    Object.keys({ [field]: 0 }).forEach(key => (opSlw as any)[key as any]);
                    const rootSlw = new SelectionWrapper(
                        undefined,
                        undefined,
                        undefined,
                        opSlw,
                        root,
                    );
                    opSlw[ROOT_OP_COLLECTOR] = rootRef;
                    // access the keys of the proxy object, to register operations
                    Object.keys({ [field]: 0 }).forEach(key => (rootSlw as any)[key as any]);

                    const resultProxy = new Proxy(
                        {},
                        {
                            get(_t, _prop) {
                                if (String(_prop) === "$lazy") {
                                    return (fieldSlw as any)["$lazy"].bind({
                                        parentSlw: opSlw,
                                        key: field,
                                    });
                                } else {
                                    const result = new Promise((resolve, reject) => {
                                        root.execute()
                                            .catch(reject)
                                            .then(() => {
                                                resolve((rootSlw as any)[field]);
                                            });
                                    });
                                    if (String(_prop) === "then") {
                                        return result.then.bind(result);
                                    }
                                    return result;
                                }
                            },
                        },
                    ) as any;

                    return new Proxy(
                        {},
                        {
                            get(_t, _prop) {
                                if (String(_prop) === "auth") {
                                    return (auth: FnOrPromisOrPrimitive) => {
                                        root.op!.setAuth(auth);
                                        return resultProxy;
                                    };
                                }
                                return resultProxy[_prop];
                            },
                        },
                    );
                }
            };

            
                Object.defineProperty(__client__, "query", {
                    enumerable: false,
                    get() {
                        return new Proxy(
                            {},
                            {
                                get(
                                    target,
                                    op: Exclude<
                                        keyof ReturnTypeFromQuerySelection,
                                        "$fragment" | "$scalars" | "$all"
                                    >,
                                ) {
                                    return _makeOperationShortcut("Query", op);
                                },
                            },
                        );
                    },
                });
            

            export default __client__ as typeof __client__ & {
                init: typeof __init__;
            } & {
                query: {
                                [field in Exclude<
                                    keyof ReturnType<typeof makeQuerySelectionInput>,
                                    "$fragment" | "$scalars" | "$all"
                                >]: ReturnType<
                                    typeof makeQuerySelectionInput
                                >[field] extends SelectionWrapperImpl<
                                    infer FN,
                                    infer TTNP,
                                    infer TTAD,
                                    infer VT,
                                    infer AT
                                >
                                    ? Promise<ToTArrayWithDepth<SLW_TPN_ToType<TTNP>, TTAD>> & {
                                        $lazy: () => Promise<
                                            Promise<ToTArrayWithDepth<SLW_TPN_ToType<TTNP>, TTAD>>
                                        > & {
                                                    auth: (
                                                        auth: FnOrPromisOrPrimitive,
                                                    ) => Promise<
                                                        Promise<ToTArrayWithDepth<SLW_TPN_ToType<TTNP>, TTAD>>
                                                    >
                                                }
                                            ;
                                        auth: (token: FnOrPromisOrPrimitive) => Promise<"T"> & {
                                            $lazy: () => Promise<
                                                Promise<ToTArrayWithDepth<SLW_TPN_ToType<TTNP>, TTAD>>
                                            >;
                                        };
                                    }
                                    : ReturnType<typeof makeQuerySelectionInput>[field]extends (
                                            args: infer A,
                                        ) => (selection: any) => any
                                    ? (args: A) => ReturnTypeFromQuerySelectionRetTypes<1>[field]
                                    : ReturnType<typeof makeQuerySelectionInput>[field] extends (
                                        args: infer _A,
                                    ) => SelectionWrapperImpl<
                                        infer _FN,
                                        infer _TTNP,
                                        infer _TTAD,
                                        infer _VT,
                                        infer _AT
                                    >
                                    ? (args: _A) => Promise<ToTArrayWithDepth<SLW_TPN_ToType<_TTNP>,_TTAD>> & {
                                        $lazy: (args: _A) => Promise<
                                            Promise<ToTArrayWithDepth<SLW_TPN_ToType<_TTNP>, _TTAD>>
                                        > & {
                                                    auth: (
                                                        auth: FnOrPromisOrPrimitive,
                                                    ) => Promise<
                                                        Promise<ToTArrayWithDepth<SLW_TPN_ToType<_TTNP>, _TTAD>>
                                                    >;
                                                }
                                            ;
                                        auth: (token: FnOrPromisOrPrimitive) => Promise<"T"> & {
                                            $lazy: () => Promise<
                                                Promise<ToTArrayWithDepth<SLW_TPN_ToType<_TTNP>, _TTAD>>
                                            >;
                                        };
                                    }
                                    : ReturnTypeFromQuerySelectionRetTypes<1>[field];
                            };
            }
        